// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./Utils/Images/aiimage.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* @import url("./style/cssFileName.css"); */

.App {
  text-align: center;
}

.tawkloader_css {
  position: fixed;
  bottom: 17px;
  right: 23px;
  background-color: #BCE879;
  padding: 12px;
  border-radius: 50%;
  height: 65px;
  cursor: pointer;
  z-index: 9999999999999 !important;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

.form-wrapper {
  background-color: #222629;
  color: #fff;
}

input.react-international-phone-input {
  width: 100%;
}

.pass-toggle {
  text-align: end;
  position: absolute;
  right: 25px;
  top: 40px;
}

.pass-toggle1 {
  text-align: end;
  position: absolute;
  right: 25px;
  top: 48px;
}

.pass-toggle-reg {
  text-align: end;
  position: absolute;
  right: 25px;
  top: 40px;
}

.password-toggle-icon {
  width: 20px;
  height: 20px;
  cursor: pointer;
}

.center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.header {
  display: flex;
  align-items: center;
  padding: 0.5rem;
}

.logo-container {
  flex: 0 0 auto;
}

.logo {
  height: 55px;
  width: 100px;
  cursor: pointer;
}

.ant-upload.ant-upload-select {
  margin: 0 15px 0 0;
}

.ant-form-item-explain-error {
  text-align: start;
}

span.ant-upload-list-item-name {
  word-break: break-all;
  max-width: 170px;
}

.profile-edit {
  border: none;
  background: #17c1e8 !important;
  color: white;
  width: 116px;
  height: 35px;
  border-radius: 7px;
  align-items: right;
  margin: 0px 25px 0 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* //////////////////////////////////////////////////  */
.profile-update {
  border: none;
  background: #58838d !important;
  color: white;
  width: 116px;
  height: 35px;
  border-radius: 7px;
  align-items: right;
  margin: 0px 79px 0 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.ant-modal-body {
  padding: 30px 30px 0 30px !important;
}

.ant-modal-footer {
  margin: 0 0 0 0 !important;
  padding: 0 30px 30px 30px !important;
}

.profile-section .card-body {
  background: #fff;
  box-shadow: rgb(149 157 165 / 7%) 0px 8px 24px;
  padding: 40px 40px;
  border: none !important;
  outline: none !important;
  border-color: transparent !important;
  border-radius: 18px;
}

.profile-section .card.mb-4 {
  border: none !important;
  background: transparent !important;
}

.content-dasboard h1.ant-typography.css-dev-only-do-not-override-98ntnt {
  color: #3e3e3e;
}

.button.ant-btn.css-dev-only-do-not-override-1drr2mu.ant-btn-default {
  float: left;
}

.active {
  background-color: #000;
}

.resend-otp {
  text-align: center;
  margin-top: 20px;
}

.btn-100 {
  width: 100%;
}

/* ::-webkit-scrollbar {
  width: 5px;
} */

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

body {
  background: #f8f9fa;
  font-family: "Jost", sans-serif;
}

.side-bar {
  min-height: 100vh;
  max-height: calc(100% - 0px);
  transform: translateX(0%);
  width: 240px;
  position: fixed;
  left: 0;
  top: 0;
  transition: 0.5s;
  z-index: 1;
  overflow: auto;
  background: #fff;
  box-shadow: rgb(149 157 165 / 7%) 0px 8px 24px;
}
/* ul.link-ul a {
  color: #fff !important;
} */

.login_background_css {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: auto;
  background-color: #222629;
  min-height: 100vh;
}

.open-class .side-bar {
  left: -260px;
}

.open-class .dasboard-all .container-fluid {
  padding-left: 30px;
}

.logo-sec h1 {
  color: #17c1e8 !important;
}

.link-ul {
  margin: 0;
  padding: 0;
  list-style: none;
}

/* .link-ul li a {
  font-size: 16px;
  color: #67748e;
  text-decoration: none;
  display: block;
  padding: 10px 25px;
  border-radius: 10px;
  margin: 0 0 5px 0;
  cursor: pointer;
  transition: 0.3s;
} */

.link-ul li a {
  font-size: 16px;
  color: #67748e;
  text-decoration: none;
  display: block;
  padding: 10px 25px;
  border-radius: 10px;
  margin: 0 0 5px 0;
  cursor: pointer;
  transition: 0.3s;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
}

a.active {
  cursor: pointer !important;
}

.link-ul li a.active,
.link-ul li a:hover {
  background-color: #17c1e8;
  color: #fff;
}

.link-div {
  padding: 21px 15px;
}

.logo-top {
  max-width: 140px;
  margin: auto;
  display: block;
  margin-bottom: 25px;
}

.dasboard-all .container-fluid {
  padding-left: 270px;
  padding-right: 30px;
  transition: 0.5s;
}

.link-ul li a i {
  margin: 0 12px 0 0 !important;
}

.dasboard-all.top-header {
  padding: 5px 0 5px 0;

  background: #17c1e8;
  background: #f8f9fa;
  border-bottom: 1px solid #efefef;
}

.header-flex ul {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

button.w-100.p-2.gmail_button_css {
  background: #141727;
  color: white;
  width: 60% !important;
  font-size: 13px;
  margin: auto;
  display: block;
  padding: 12px 15px !important;
  border-radius: 0.25rem !important;
}

.insta_button_css {
  background: #141727;
  color: white;
  width: 60% !important;
  font-size: 13px;
  margin: auto;
  display: block;
  padding: 12px 15px !important;
  border-radius: 0.25rem !important;
}

.tog-bt {
  display: block;
  padding: 0px 10px;
  border-radius: 10px;
  margin: 0 0 0px 0;
  transition: 0.3s;
  background: #98bdff;
  color: #fff;
  border: none;
  height: 35px;
  width: 45px;
  text-align: center;
  line-height: 35px;
}

.header-flex ul li button {
  background: #17c1e8 !important;
  font-size: 14px;
  font-weight: 600 !important;
  border-radius: 4px !important;
  padding: 0 15px !important;
  height: 40px !important;
  line-height: 40px !important;
}

.line-1 {
  height: 2px;
  width: 30px;
  background: #fff;
  display: block;
  margin: 4px 0;
  border-radius: 23px;
}

.log-out-bt {
  cursor: pointer;
  padding: 5px 30px 5px 30px;
  font-size: 15px;
  font-weight: 400;
  height: 40px;
  font-family: "Jost", sans-serif;
  border-radius: 100px;
  background: rgb(123 144 183);
  border: none;
  color: #fff;
}

/* .top-header i.fa-solid.fa-bars {
  display: none;
} */

.top-header .fa-solid.fa-bars {
  display: none;
}

/* .open-class .top-header i.fa-solid.fa-caret-left {
  display: none;
} */

.open-class .top-header .fa-solid.fa-caret-left {
  display: none;
}

/* .open-class .top-header i.fa-solid.fa-bars {
  display: block;
} */

.open-class .top-header .fa-solid.fa-bars {
  display: block;
}

.last-table {
  overflow: auto;
}

.last-table table {
  width: 100%;
  min-width: 800px;
}

.last-table table thead tr th {
  font-size: 16px;
  color: #ffffff;
  padding: 15px 15px;
  background: #76b51b;
  font-weight: bold;
}

.last-table table tbody tr td {
  font-size: 16px;
  color: #535353;
  padding: 15px 15px;
  background: #ffffff;
  font-weight: 400;
}

.last-table table thead tr th:nth-child(1) {
  border-top-left-radius: 12px;
}

.last-table table thead tr th:last-child {
  border-top-right-radius: 12px;
}

.last-table table tbody tr:last-child td:nth-child(1) {
  border-bottom-left-radius: 12px;
}

.last-table table tbody tr:last-child td:last-child {
  border-bottom-right-radius: 12px;
}

.content-dasboard {
  padding: 10px 0;
}

.last-table table tbody tr:nth-child(even) td {
  background: #76b51b14;
}

.last-table table tbody tr:hover td {
  background: #76b51b38;
}

.search-input .same-input {
  border: 1px solid #f7f7f7;
  background: #fff;
  width: 100%;
  height: 50px;
  border-radius: 12px;
  font-size: 16px;
  padding: 0 15px;
  max-width: 140px;
  margin: 0 0 0 0;
  color: #535353;
}

.search-input .same-input:hover,
.search-input .same-input:focus {
  outline: 2px solid #76b51b;
}

.input-ul {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
}

.input-ul li {
  margin: 0 15px 15px 0;
}

.bt-search {
  border: 1px solid #f7f7f7;
  background: #76b51b;
  width: 100%;
  height: 50px;
  border-radius: 12px;
  font-size: 16px;
  padding: 0 15px;
  max-width: 160px;
  margin: 0 0 0 0;
  color: #ffffff;
}

.all-label {
  color: #535353;
  font-size: 16px;
  margin: 0 5px 0 0;
}

.profile-details {
  display: flex;
  justify-content: center;
}

.form-size {
  width: 100%;
  max-width: 600px;
  background: #fff;
  padding: 30px;
  box-shadow: rgb(149 157 165 / 7%) 0px 8px 24px;
  border: none !important;
  outline: none !important;
  border-color: transparent !important;
  border-radius: 18px;
}

.profile-edit-modal {
  max-width: calc(100vw - 32px);
  margin: 16px auto;
}

.profile-edit-modal .ant-modal-body {
  max-height: calc(100vh - 110px);
  max-height: calc(100dvh - 110px);
  overflow-y: auto;
  overscroll-behavior: contain;
  padding: 16px 20px 20px !important;
  scrollbar-gutter: stable;
}

.profile-edit-modal .form-size {
  max-width: none;
  padding: 12px;
  box-shadow: none;
}

/* .form_custom_css{
  background: #fff;
  box-shadow: rgb(149 157 165 / 7%) 0px 8px 24px;
  border: none !important;
  outline: none !important;
  border-color: transparent !important;
  border-radius: 18px;
} */

.update-btn {
  width: 100%;
  color: #fff;
  background-color: #17c1e8 !important;
}

@media (min-width: 768px) {
  .abs-bk {
    display: none;
  }
}

/* ***********************MOBILE RESPONSIVE CSSS******************************* */
@media (max-width: 767px) {
  .dasboard-all .container-fluid {
    padding-left: 15px;
    padding-right: 15px;
  }

  .resp_add_social_info {
    flex-direction: column;
    align-items: center !important;
  }

  .resp_add_social_info button {
    background: rgb(64, 93, 230);
    color: white;
    width: 100% !important;
    padding: 10px;
    font-size: 13px;
  }

  .resp_height {
    height: 495px !important;
  }

  .open-class .dasboard-all .container-fluid {
    padding-left: 15px;
    padding-right: 15px;
  }

  .side-bar {
    left: -270px;
  }

  .open-class .side-bar {
    left: 0px;
  }

  /* .abs-bk i {
    color: #fff;
    font-size: 15px;
    position: fixed;
    right: -10px;
    top: 110px;
    background-color: #17c1e8;
    width: 20px;
    height: 20px;
    text-align: center;
    border-radius: 30px;
    line-height: 20px;
  } */

  .abs-bk .icon {
    color: #fff;
    font-size: 15px;
    position: fixed;
    right: 0px;
    top: 110px;
    background-color: #17c1e8;
    width: 20px;
    height: 20px;
    text-align: center;
    border-radius: 30px;
    line-height: 20px;
  }

  .resp_otp_css {
    border-radius: 15px;
    z-index: 99999;
    width: 321px !important;
  }

  .resp_otp_css_form input {
    width: 243px !important;
  }

  .Chat_bot_css {
    height: 80vh !important;
    border-radius: 20px !important;
    padding: 20px !important;
    position: relative !important;
  }

  .chat_bot_input_css input {
    padding: 10px !important;
    border-radius: 8px !important;
    border: 1px solid darkslategrey !important;
    margin: 0 0 10px 0;
  }

  .chat_bot_button_css button {
    border-radius: 8px !important;
    width: 260px !important;
    padding: 10px !important;
    background: #f3797e !important;
    color: white;
    border: none !important;
  }
}

.login-22 {
  top: 0;
  width: 100%;
  text-align: center;
  bottom: 0;
  opacity: 1;
  z-index: 999;
  min-height: 100vh;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 30px 0;
}

.register_css {
  margin-top: 0px !important;
}

.form_css {
  width: 100% !important;
  max-width: 580px;
  margin: 0 !important;
  background: #fff;
  box-shadow: rgb(149 157 165 / 7%) 0px 8px 24px;
  padding: 30px 30px !important;
  border: none !important;
  outline: none !important;
  border-color: transparent !important;
  border-radius: 18px;
}

.d-flex.justify-content-center.gap-3.my-5.resp_add_social_info {
  flex-wrap: wrap;
}

.instagram_input_css {
  font-size: 13px;
  padding: 8px;
}

.instagram_logo_css {
  background: radial-gradient(circle at 30% 107%, #fdf497 0%, #fdf497 5%, #fd5949 45%, #d6249f 60%, #285aeb 90%);
  color: white;
  border-radius: 24px;
  padding: 5px;
  margin-top: 20px;
}

.Label_css {
  text-align: center;
  font-size: 20px;
  font-weight: 500;
  font-family: math;
}

.login-22 a {
  text-decoration: none;
}

.login-22 h1,
h2,
h3,
h4,
h5,
h6,
.h1,
.h2,
.h3,
.h4,
.h5,
.h6 {
  font-family: "Jost", sans-serif;
}

.login-22 .form-section {
  max-width: 550px;
  margin: 0 auto;
}

.login-22 .form-section .details {
  padding: 80px;
  border-radius: 5px;
  margin-bottom: 30px;
  background: #f5f5f5;
  position: relative;
  z-index: 0;
}

.login-22 .form-check-input:checked {
  display: none;
}

.login-22 .form-section p {
  color: #535353;
  margin-bottom: 0;
  font-size: 16px;
}

.login-22 .form-section p a {
  color: #535353;
}

.login-22 .form-section ul {
  list-style: none;
  padding: 0;
  margin: 0 0 20px;
}

.login-22 .form-section .social-list li {
  display: inline-block;
  margin-bottom: 5px;
}

.login-22 .logo-2 img {
  margin-bottom: 10px;
  height: 70px;
}

.login-22 .form-section .thembo {
  margin-left: 4px;
}

.login-22 .form-section h3 {
  margin: 0 0 40px;
  font-size: 25px;
  font-weight: 400;
  font-family: "Jost", sans-serif;
  color: #040404;
}

.login-22 .form-section .form-group {
  margin-bottom: 40px;
}

.login-22 .form-section .form-box {
  float: left;
  width: 100%;
  position: relative;
  text-align: left;
}

.login-22 .form-section .form-control {
  font-size: 16px;
  outline: none;
  background: transparent !important;
  color: #535353;
  border-radius: 0;
  padding-left: 0;
  padding-right: 0;
  border: none;
  border-bottom: solid 2px #bdbdbd;
}

.login-22 .form-section .btn-md {
  cursor: pointer;
  padding: 12px 50px 11px 50px;
  font-size: 15px;
  font-weight: 400;
  height: 55px;
  font-family: "Jost", sans-serif;
  border-radius: 100px;
}

.login-22 .form-section button:focus {
  outline: none;
  outline: 0 auto -webkit-focus-ring-color;
}

.login-22 .form-section .btn-theme.focus,
.btn-theme:focus {
  box-shadow: none;
}

.login-22 .form-section .terms {
  margin-left: 3px;
}

.login-22 .form-section input[type="checkbox"],
input[type="radio"] {
  margin-top: 4px;
}

.login-22 .form-section .checkbox a {
  float: right;
}

.login-22 .form-section .checkbox {
  margin-bottom: 30px;
  font-size: 15px;
}

.login-22 .form-section .form-check {
  float: left;
  margin-bottom: 0;
  padding-left: 0;
}

.login-22 .form-section .form-check a {
  color: #535353;
  float: right;
}

.login-22 .form-section .form-check-input {
  position: absolute;
  margin-left: 0;
}

.login-22 .form-section .form-check label::before {
  content: "";
  display: inline-block;
  position: absolute;
  width: 18px;
  height: 18px;
  top: 2px;
  margin-left: -25px;
  border-radius: 0px;
  background: #f5f5f5;
  border: solid 2px #bdbdbd;
}

.login-22 .form-section .form-check-label {
  padding-left: 25px;
  margin-bottom: 0;
  font-size: 16px;
  color: #535353;
}

.login-22 .form-section input[type="checkbox"]:checked + label:before {
  font-weight: 600;
  color: #fff;
  line-height: 14px;
  font-size: 12px;
  content: "\\2713";
  padding-left: 3px;
}

.login-22 .form-section .form-control:focus {
  outline: none;
  box-shadow: none;
}

.login-22 .form-section .checkbox-theme input[type="checkbox"]:checked + label::before {
  color: #fff;
  background: #76b51b;
  border: solid 2px #76b51b;
}

.login-22 .form-section .btn-theme {
  background: #76b51b;
  border: none;
  color: #fff;
}

.login-22 .form-section .btn-theme:hover {
  background: #7dc11c;
}

.login-22 .form-section a.forgot-password {
  font-size: 16px;
  color: #535353;
}

.login-22 .social-list {
  float: left;
}

.login-22 .social-list span {
  margin-right: 5px;
  font-weight: 500;
  font-size: 15px;
  color: #535353;
}

.login-22 .social-list a {
  width: 55px;
  height: 55px;
  line-height: 55px;
  text-align: center;
  display: inline-block;
  font-size: 15px;
  color: rgb(255, 255, 255);
  margin: 0 2px 2px 0;
  border-radius: 50px;
}

.login-22-bodycolor .ripple-background {
  z-index: -999 !important;
}

.login-22-bodycolor .ripple-background .circle {
  position: absolute;
  border-radius: 50%;
  animation: ripple 15s infinite;
}

.login-22-bodycolor .ripple-background .small {
  width: 200px;
  height: 200px;
  left: -100px;
  top: -100px;
  z-index: -999;
}

.login-22-bodycolor .ripple-background .medium {
  width: 400px;
  height: 400px;
  left: -200px;
  bottom: -200px;
  z-index: -999;
}

.login-22-bodycolor .ripple-background .large {
  width: 600px;
  height: 600px;
  left: -300px;
  top: -300px;
  z-index: -999;
}

.login-22-bodycolor .ripple-background .xlarge {
  width: 800px;
  height: 800px;
  left: -400px;
  top: -400px;
  z-index: -999;
}

.login-22-bodycolor .ripple-background .xxlarge {
  width: 1000px;
  height: 1000px;
  left: -500px;
  top: -500px;
  z-index: -999;
}

.login-22-bodycolor .ripple-background .shade1 {
  background: #0000ff26;
}

.login-22-bodycolor .ripple-background .shade2 {
  background: #b9b9ff;
}

.login-22-bodycolor .ripple-background .shade3 {
  background: #0000ff26;
}

.login-22-bodycolor .ripple-background .shade4 {
  background: #0a58ca;
}

.login-22-bodycolor .ripple-background .shade5 {
  background: #0000ff26;
}

@keyframes ripple {
  0% {
    transform: scale(0.8);
  }

  50% {
    transform: scale(1.2);
  }

  100% {
    transform: scale(0.8);
  }
}

.login-22 .facebook-bg {
  background: #4867aa;
}

.login-22 .facebook-bg:hover {
  background: #3b589e;
}

.login-22 .twitter-bg {
  background: #33ccff;
}

.login-22 .twitter-bg:hover {
  background: #2abdef;
}

.login-22 .google-bg {
  background: #db4437;
}

.login-22 .google-bg:hover {
  background: #cc4437;
}

.login-22 .linkedin-bg {
  background: #2392e0;
}

.login-22 .linkedin-bg:hover {
  background: #1c82ca;
  color: #fff;
}

.ripple-background {
  z-index: -999 !important;
}

.ripple-background .circle {
  position: absolute;
  border-radius: 50%;
  animation: ripple 15s infinite;
}

.ripple-background .small {
  width: 200px;
  height: 200px;
  left: -100px;
  top: -100px;
  z-index: -999;
}

.ripple-background .medium {
  width: 400px;
  height: 400px;
  left: -200px;
  bottom: -200px;
  z-index: -999;
}

.ripple-background .large {
  width: 600px;
  height: 600px;
  left: -300px;
  top: -300px;
  z-index: -999;
}

.ripple-background .xlarge {
  width: 800px;
  height: 800px;
  left: -400px;
  top: -400px;
  z-index: -999;
}

.ripple-background .xxlarge {
  width: 1000px;
  height: 1000px;
  left: -500px;
  top: -500px;
  z-index: -999;
}

.ripple-background .shade1 {
  background: #76b51b3d;
}

.ripple-background .shade2 {
  background: #76b51b1f;
}

.ripple-background .shade3 {
  background: #76b51b40;
}

.ripple-background .shade4 {
  background: #0a58ca;
}

.ripple-background .shade5 {
  background: #76b51b73;
}

@keyframes ripple {
  0% {
    transform: scale(0.8);
  }

  50% {
    transform: scale(1.2);
  }

  100% {
    transform: scale(0.8);
  }
}

/* .dasboard-all.pages {
  min-height: 100vh;
} */

.dasboard-all.pages {
  min-height: calc(100vh - 130px);
}

.custom-row-bk hr {
  display: none;
}

.custom-row-bk .row {
  padding: 15px 15px;
  background: #f5f7ff;
  border-radius: 12px;
}

.custom-row-bk .row:nth-child(odd) {
  background: #fff;
}

.custom-row-bk .text-muted {
  margin: 0;
}

.footer {
  position: sticky;
  bottom: 0px;
  width: 100%;
  background: #fbfbfb;
}

.footer h1 {
  font-size: 19px;
  padding: 0px;
  font-family: initial;
  text-align: center;
  color: white;
  margin: 0;
  line-height: 50px;
}

@media (max-width: 768px) {
  .form_css {
    background: #fff;
    border: 1px solid #dbdada;
    border-radius: 4px;
    height: 520px;
    margin: auto;
    margin-top: 79px !important;
    padding: 30px;
    width: 100%;
    border-radius: 18px;
  }

  section.background-radial-gradient.overflow-hidden.min-100 {
    padding: 0 25px;
  }

  /* .pass-toggle {
  text-align: end;
  position: absolute;
  right: 40px;
  top: 249px;
} */

  .login-22 .form-section .details {
    padding: 50px 30px;
  }

  .login-22-bodycolor .ripple-background {
    display: none;
  }
}

@media (max-width: 767px) {
  .ripple-background {
    display: none;
  }
}

.login-container {
  width: 100%;
  max-width: 400px;
  margin: 0 auto;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.login-form {
  display: flex;
  flex-direction: column;
}

.login-form input {
  margin-bottom: 10px;
  padding: 10px;
  font-size: 16px;
  border-radius: 5px;
  border: 1px solid #ccc;
}

.login-form button {
  padding: 10px;
  font-size: 16px;
  border-radius: 5px;
  border: none;
  background-color: #007bff;
  color: #fff;
  cursor: pointer;
}

.login-form button:hover {
  background-color: #0056b3;
}

.background-radial-gradient {
  display: flex;
  align-items: center;
  justify-content: center;
}

.min-100 {
  min-height: 100vh;
}

#radius-shape-1 {
  height: 220px;
  width: 220px;
  top: -60px;
  left: -130px;
  background: radial-gradient(#44006b, #ad1fff);
  overflow: hidden;
}

#radius-shape-2 {
  border-radius: 38% 62% 63% 37% / 70% 33% 67% 30%;
  bottom: -40px;
  right: -110px;
  width: 300px;
  height: 300px;
  background: radial-gradient(#3d383f, #ad1fff);
  overflow: hidden;
}

.bg-glass {
  background-color: hsla(0, 0%, 100%, 0.9) !important;
  backdrop-filter: saturate(200%) blur(25px);
}

.bg_login_css {
  background: #fff;
  box-shadow: rgb(149 157 165 / 7%) 0px 8px 24px;
  border: none !important;
  outline: none !important;
  border-color: transparent !important;
  border-radius: 18px;
}

.bg_register_css {
  background: #fff;
  box-shadow: rgb(149 157 165 / 7%) 0px 8px 24px;
  border: none !important;
  outline: none !important;
  border-color: transparent !important;
  border-radius: 18px;
}

@media screen and (max-width: 480px) {
  #radius-shape-2 {
    border-radius: 38% 62% 63% 37% / 70% 33% 67% 30%;
    bottom: -60px;
    right: 0px !important;
    width: 300px;
    height: 300px;
    background: radial-gradient(#44006b, #ad1fff);
    overflow: hidden;
  }
}

.country_css {
  width: 100%;
  padding: 5px;
  border: 1px solid #dbd1d1;
  border-radius: 4px;
}

.city_css {
  width: 100%;
  padding: 5px;
  border: 1px solid #dbd1d1;
  border-radius: 4px;
}

.Instagram_consent_css_container {
  max-width: 600px;
  margin: 0 auto;
  width: 100%;
  max-width: 441px;
  background: #fff;
  margin-top: 26px !important;
  margin: auto;
  height: 570px;
  border-radius: 7px;
  padding: 30px;
  border: 1px solid #dbdada;
}

.Instagram_consent_css_container h1 {
  text-align: center;
}

.Instagram_consent_css_container p {
  margin-bottom: 20px;
}

.Instagram_consent_css_container button {
  display: block;
  margin: 0 auto;
  padding: 10px 20px;
  background-color: #405de6;
  color: #fff;
  width: 50%;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.Instagram_consent_css_container button:hover {
  background-color: #577eea;
}

.Revoke_css_container {
  max-width: 600px;
  margin: 0 auto;
  width: 100%;
  max-width: 441px;
  background: #fff;
  margin-top: 56px !important;
  margin: auto;
  height: 520px;
  border-radius: 7px;
  padding: 30px;
  border: 1px solid #dbdada;
}

.Revoke_css_container h1 {
  text-align: center;
}

.Revoke_css_container p {
  margin-bottom: 20px;
}

.Revoke_css_container button {
  display: block;
  margin: 0 auto;
  padding: 10px 20px;
  /* background-color: #FF5A60; */
  background-color: #405de6;
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.Revoke_css_container button:hover {
  /* background-color: #FF7B81; */
  background-color: #577eea;
}

.form_button_css:hover {
  background-color: #577eea !important;
}

.delete_user_css_container {
  max-width: 600px;
  margin: 0 auto;
  width: 100%;
  max-width: 441px;
  background: #fff;
  margin-top: 38px !important;
  margin: auto;
  height: 520px;
  border-radius: 4px;
  padding: 30px;
  border: 1px solid #dbdada;
}

.delete_user_css_container h1 {
  text-align: center;
}

.delete_user_css_container p {
  margin-bottom: 20px;
}

.delete_user_css_container button {
  display: block;
  margin: 0 auto;
  padding: 10px 20px;
  /* background-color: #FF5A60; */
  background-color: #405de6;
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.delete_user_css_container button:hover {
  /* background-color: #FF7B81; */
  background-color: #577eea;
}

.footer_custom_css {
  position: sticky;
  bottom: 0px;
  padding: 10px;
  width: 100%;
  background: #fbfbfb;
}

.footer_custom_css h1 {
  font-size: 19px;
  padding: 14px;
  font-family: initial;
  text-align: center;
  color: white;
  height: 10px;
}

.privacyPolicy_css {
  background: #fff;
  box-shadow: rgb(149 157 165 / 7%) 0px 8px 24px;
  padding: 40px 40px;
  border: none;
  outline: none;
  border-color: transparent;
  border-radius: 18px;
}

.privacyPolicy_css h1 {
  color: #17c1e8;
  margin: 0 0 22px 0;
  font-size: 40px !important;
}

.privacyPolicy_css h5,
.privacyPolicy_css h3 {
  color: #141727 !important;
  margin: 0 0 22px 0;
}

.privacyPolicy_css p {
  margin: 0 0 22px 0;
  color: #67748e;
}

li.text-list {
  color: #67748e;
}
.tiktok_css {
  background: #fff;
  box-shadow: rgb(149 157 165 / 7%) 0px 8px 24px;
  padding: 30px 30px;
  border: none;
  outline: none;
  border-color: transparent;
  border-radius: 18px;
  width: 50%;
  margin: auto;
}

.faq_css {
  background: #fff;
  box-shadow: rgb(149 157 165 / 7%) 0px 8px 24px;
  padding: 40px 40px;
  border: none;
  outline: none;
  border-color: transparent;
  border-radius: 18px;
  width: 50%;
  margin: auto;
  margin-top: 65px;
}

.faq_css h1 {
  color: #17c1e8;
  margin: 0 0 22px 0;
  font-size: 40px !important;
}

.faq_css h5,
.faq_css h3 {
  color: #141727 !important;
  margin: 0 0 22px 0;
}

.faq_css p {
  margin: 0 0 22px 0;
  color: #67748e;
}

/* **************CHATBOT CSSS*************************** */

/* .Chat_bot_css {

  background-color: hsl(218, 41%, 15%);
  background-image: radial-gradient(650px circle at 0% 0%, hsl(218, 41%, 35%) 15%, hsl(218, 41%, 30%) 35%, hsl(218, 41%, 20%) 75%, hsl(218, 41%, 19%) 80%, transparent 100%),
    radial-gradient(1250px circle at 100% 100%, hsl(218, 41%, 45%) 15%, hsl(218, 41%, 30%) 35%, hsl(218, 41%, 20%) 75%, hsl(218, 41%, 19%) 80%, transparent 100%);

  border-radius: 20px;
  padding: 20px;
  position: relative;
  padding-bottom: 110px;
  
  background: #fff;
  box-shadow: rgb(149 157 165 / 7%) 0px 8px 24px;
  border: none !important;
  outline: none !important;
  border-color: transparent !important;
  border-radius: 18px;
} */

.Chat_bot_css {
  padding: 20px;
  position: relative;
  padding-bottom: 120px;

  background: white;
  box-shadow: rgb(149 157 165 / 7%) 0px 8px 24px;
  border: none !important;
  outline: none !important;
  border-color: transparent !important;
  border-radius: 18px;
}

.input_css_for_all_placeholder {
  background: #f8f9fa !important;
  min-height: 20px !important;
}

.Chat_bot_cssAiagent {
  padding: 20px;
  position: relative;
  padding-bottom: 90px;
  min-height: calc(100vh - 150px);
  background: white;
  box-shadow: rgb(149 157 165 / 7%) 0px 8px 24px;
  border: none !important;
  outline: none !important;
  border-color: transparent !important;
  border-radius: 18px;
}

.chat_bot_h1_css h1 {
  color: #3e3e3e !important;
  font-size: 40px !important;
  font-weight: 600 !important;
  font-family: fangsong !important;
}

.chat_bot_input_css input {
  padding: 10px;
  border-radius: 8px;
  border: 1px solid darkslategrey;
  width: 100%;
  background: #f5f7ff !important;
}

.chat_bot_button_css.mx-2 button {
  width: 100%;
  background: rgb(243, 121, 126);
  color: white;
  border: none;
}

.chat_bot_button_css button {
  border-radius: 8px;
  width: 150px;
  padding: 10px;
  background: white;
  border: 1px solid darkslategrey;
}

.main_input_css {
  align-items: center;
  background-color: transparent;
  /* border: 1px solid #a9a9a9; */
  border-radius: 12px;
  padding: 10px;
  position: absolute;
  bottom: 20px;
  width: 95%;
  flex-wrap: wrap;
  justify-content: space-between !important;
  margin: auto;
  display: block;
  left: 0;
  right: 0;
}

/* **********Question_css******* */

.Question_css {
  border-radius: 12px;
  /* border: 1px solid darkgrey; */
  padding: 5px;
  background: #f5f7ff;
}

.Question_cssAiagent {
  border-radius: 12px;
  /* border: 1px solid darkgrey; */
  padding: 5px;
  background: #f5f7ff;
  width: fit-content;
  max-width: 70%;
}

.Answer_cssAiagent {
  border-radius: 12px;
  display: flex;
  align-items: center;
  gap: 10px;
  max-width: 70%;
  /* border: 1px solid darkgrey; */
  padding: 15px;
  background: #f5f7ff;
  width: fit-content;
}

.Answer_css {
  border-radius: 12px;
  /* border: 1px solid darkgrey; */
  padding: 15px;
  background: #f5f7ff;
}

.message_css {
  overflow-y: auto;
  height: 295px;
}

.message_cssAiagent {
  overflow-y: auto;
  height: calc(100vh - 440px);
  /* min-height: 100vh; */
}

/* ---------------------------------------------------------------------------------- */

.animated-text {
  font-family: Arial, sans-serif;
  white-space: pre-wrap;
  /* Preserve line breaks */
  overflow: hidden;
  /* Hide overflow content */
}

/* Animation */
@keyframes typing {
  from {
    width: 0;
  }

  to {
    width: 100%;
  }
}

.animated-text::after {
  content: "|";
  /* Cursor */
  display: inline-block;
  width: 0;
  animation: typing 1s steps(44) infinite;
}

/* Hide cursor when text is fully typed */
.animated-text::after {
  animation: none;
}

.chat_bot_input_css {
  width: 50%;
  margin: 0;
}

.chat_bot_button_css.mx-2 {
  width: 23%;
  margin: 0 !important;
  display: flex;
  justify-content: center;
}

/* ******************** MAIL CSSS************************************ */

.mail_css {
  display: flex;
  width: 100%;
  background: red;
  padding: 15px;
  height: 100vh;
}

.Insta_css_message {
  width: 100%;
  padding: 20px;
  border-radius: 10px;
  display: flex;
  justify-content: center;
}

.instagram_conatiner_css {
  /* background: #e1e1e1; */
  background: white;
  padding: 20px;
  border-radius: 7px;
  padding: 20px;
  width: 50%;
}

.mail_css_form {
  border: 1px solid darkgrey;
  height: auto;
  padding: 20px;
  border-radius: 10px;
  background: white;
}

/* .mail_css_form p {
  word-break: break-all;
} */

.mail_css_form li {
  word-break: break-all;
}

.d-flex.custom-flex-100 .d-flex.justify-content-start.rounded-3.p-2.mb-2.bg-body-tertiary {
  justify-content: space-between !important;
  padding: 15px 15px !important;
}

ul.list-name {
  padding: 20px !important;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  text-align: center;
}

ul.list-name li {
  width: 23%;
  margin: 0 0 10px 0;
}

ul.list-name hr {
  display: none !important;
}

.list-box {
  height: 110px;
  overflow-y: auto;
  padding: 0px;
}

@media (max-width: 1024px) {
  .d-flex.justify-content-start.rounded-3.p-2.mb-2.bg-body-tertiary {
    flex-wrap: wrap;
  }

  .d-flex.justify-content-start.rounded-3.p-2.mb-2.bg-body-tertiary .px-3 {
    padding: 0 !important;
  }

  .wid-100 {
    width: 100%;
  }
}

@media (max-width: 991px) {
  button.viewpost {
    width: 100% !important;
  }

  .cus-m {
    margin-bottom: 15px !important;
  }

  .d-flex.custom-flex-100 {
    flex-wrap: wrap;
  }

  .d-flex.custom-flex-100 .flex-shrink-0 {
    width: 100%;
    margin: 0 0 15px 0;
  }

  .d-flex.custom-flex-100 .flex-grow-1.ms-3 {
    margin: 0 0 0 0 !important;
  }

  .d-flex.custom-flex-100 .wid-100 {
    width: auto;
  }
}

@media (max-width: 767px) {
  .chat_bot_button_css.mx-2 {
    width: 46%;
  }

  .chat_bot_input_css {
    width: 100%;
  }

  .message_css {
    overflow-y: scroll;
    height: 450px !important;
  }

  .instagram_conatiner_css {
    width: 100% !important;
  }
}

.content-dasboard .card-body.p-4 {
  background: #fff;
  box-shadow: rgb(149 157 165 / 7%) 0px 8px 24px;
  padding: 30px 30px !important;
  border: none !important;
  outline: none !important;
  border-color: transparent !important;
  border-radius: 18px;
}

.content-dasboard .card-body.p-4.insta-body {
  padding: 0 !important;
  box-shadow: none !important;
}

.content-dasboard .card.cus-m {
  border: none;
}

.content-dasboard button.my-1.btn.btn-primary {
  background: #f3797e;
  border: none;
  margin: 5px 0 0px 0 !important;
  width: 100%;
}

.content-dasboard .flex-grow-1.ms-3 h5.mb-1 {
  font-weight: bold;
  color: #3e3e3e;
}

.content-dasboard .d-flex.justify-content-start.rounded-3.p-2.mb-2.bg-body-tertiary {
  background: #f5f7ff !important;
}

.content-dasboard p.mb-0 {
  font-weight: bold;
  color: #17c1e8;
}

.content-dasboard h2.form-header {
  color: #3e3e3e;
}

.content-dasboard button.btn.btn-primary.w-100 {
  background: #f3797e;
  border: none;
}

.ant-modal-content {
  background: #fff;
  box-shadow: rgb(149 157 165 / 7%) 0px 8px 24px;
  padding: 40px 40px;
  border: none !important;
  outline: none !important;
  border-color: transparent !important;
  border-radius: 18px;
}

.ant-modal-content button.btn.btn-primary.w-100 {
  background: #f3797e;
  height: 40px;
  border: none;
}

.ant-modal-content input {
  background: #f5f7ff !important;
  height: 40px;
  border: none !important;
  font-size: 14px !important;
  box-shadow: rgb(149 157 165 / 7%) 0px 8px 24px !important;
}

.ant-modal-content label.form-label {
  margin: 0 0 3px 0;
}

.ant-modal-content {
  padding: 0 !important;
}

.ant-modal-content .ant-modal-header {
  background: #17c1e8 !important;
  padding: 15px 15px !important;
  margin: 0 !important;
}

.ant-modal-content .ant-modal-title {
  color: #fff !important;
}

/* .ant-modal-content svg {
  fill: white;
} */

.ant-modal-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
}

.ant-modal {
  top: 0 !important;
  padding: 0 !important;
}

.background-radial-gradient {
  overflow: hidden;
  position: relative;
}

.background-radial-gradient .d-flex.justify-content-center {
  width: 100%;
}

.background-radial-gradient .d-flex.justify-content-center .row.position-absolute {
  position: static !important;
  padding: 0 !important;
}

html body .navbar_connect_button_css button.iekbcc0.iekbcc9.ju367v4.ju367va3.ju367vn.ju367vei.ju367vfu.ju367va.ju367v16.ju367v1h.ju367v8u._12cbo8i3.ju367v8r._12cbo8i4._12cbo8i6 {
  background: transparent !important;
  box-shadow: none !important;
}

.verify_otp_css {
  background: white !important;
  box-shadow: rgb(149 157 165 / 7%) 0px 8px 24px;
  border: none !important;
  outline: none !important;
  border-color: transparent !important;
  border-radius: 18px;
}

.otp_custom_css {
  background: white !important;
  box-shadow: rgb(149 157 165 / 7%) 0px 8px 24px;
  border: none !important;
  outline: none !important;
  border-color: transparent !important;
  border-radius: 18px;
}

.icons-svg {
  margin: 0px 10px 4px 0px !important;
}

.rounded-circle {
  width: 40px;
  height: 40px;
  object-fit: cover;
  margin: auto;
  display: block;
}

.rounded-circleProfile {
  width: 80px;
  height: 80px;
  object-fit: cover;
  /* margin: auto; */
  border-radius: 10%;
  display: block;
}

.profile-card p {
  font-size: 12px;
  margin: 2px 0 0 0;
}

.abs-mobile {
  font-size: 14px;
}

@media (max-width: 1024px) {
  .abs-mobile {
    font-size: 10px;
    word-break: break-all;
    position: absolute;
    width: auto;
    left: 240px;
    right: 0;
    bottom: 10px;
    text-align: center;
  }

  .dasboard-all.top-header {
    padding: 5px 0 5px 0 !important;
    position: relative;
  }
}

.Navbar_css a {
  text-decoration: none;
  color: black;
}

/* ******************************** */

.chatai_icon_css {
  color: #17c1e8 !important;
}

.delete_chatai_icon_css {
  color: red;
}

.main-div-msg {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  width: 100%;
  bottom: 20px;
  left: 0;
  z-index: 99 !important;
}

.main-div-msgchatbot {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  width: 100%;
  bottom: 29px;
  left: 0;
}

.input-box {
  width: 100%;
  max-width: 820px;
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  padding: 10px;
}

.input-group-text {
  background-color: #f1f1f1;
  border: none;
  border-radius: 10px;
}

.form-control {
  border: none;
  background-color: #f7fdfc;
  border-radius: 10px;
}

.form-control:focus {
  box-shadow: none;
  outline: none;
}

ul.first-button {
  display: flex;
  list-style: none;
  background: #f8f9fa !important;
  margin: 10px 0px 0px 0px;
  border-radius: 10px;
  padding: 0px 5px;
  gap: 5px;
}

ul.second-button {
  display: flex;
  list-style: none;
  background: #e2e8f0;
  margin: 10px 0px 0px 9px;
  border-radius: 10px;
  padding: 5px 12px;
}

ul.third-button {
  display: flex;
  list-style: none;
  margin: 10px 0px 0px 9px;
  border-radius: 10px;
  padding: 5px 12px;
  float: right;
  background: #e2e8f0;
}

ul.first-button li {
  padding: 7px 10px;
  border-radius: 10px !important;
  cursor: pointer !important;
}

.first-btn {
  display: flex;
  justify-content: flex-start;
  align-items: baseline;
}

ul.first-button li:hover {
  background: #17c1e8 !important;
  border-radius: 10px !important;
  color: #fff !important;
}

ul.second-button:hover {
  background: #17c1e8 !important;
  color: #fff !important;
}

ul.third-button:hover {
  background: #17c1e8 !important;
  color: #fff !important;
}

ul.first-button,
.second-button,
.third-button li i {
  color: #5c5b5b;
}

.active_css_aichatbot {
  background: #17c1e8 !important;
  color: white;
}

.right-ms {
  display: flex;
  justify-content: flex-end;
}

.left-ms {
  display: flex;
  justify-content: flex-start;
}
.chat-wrapper {
  position: relative;
}

.copy-button {
  position: absolute;
  top: 0;
  right: 0;
  padding: 6px 10px;
  background-color: #17c1e8;
  font-size: 12px;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  z-index: 1;
}

.copy-button:hover {
  background-color: #0056b3;
}

.chat-container {
  padding: 10px;
  border-radius: 8px;
  margin-top: 15px;
}

@media (max-width: 767px) {
  .abs-mobile {
    font-size: 14px;
  }

  .tiktok_css {
    margin-top: 20% !important;
    width: 100% !important;
  }

  .abs-mobile {
    font-size: 10px;
    word-break: break-all;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 10px;
    text-align: center;
  }

  .footer_css h1 {
    margin-left: 0px !important;
  }
}

.footer_css h1 {
  margin-left: 270px;
  color: #000;
  transition: 0.6s;
}

.footer_css_transition h1 {
  transition: 1s !important;
  color: #000;
}

.profile-pic {
  width: 200px;
  height: 200px;
}

ul.text-muted {
  display: flex;
  font-size: 19px;
  gap: 40px;
  list-style: none;
  padding: 0px;
}

.text-list {
  margin-bottom: 10px;
}

.label {
  font-size: 18px;
  color: #888;
  font-family: math;
}

.detail {
  font-size: 18px;
  font-weight: 600;
  color: black;
  margin-top: 5px;
  font-family: monospace;
}

h3.profile-detail {
  font-size: 1.5rem;
}

.text-muted {
  font-size: 0.9rem;
}

img {
  object-fit: cover;
}

ul.nav.nav-tabs {
  border-top: 1px solid #ddd;
  display: flex;
  justify-content: center;
  border-bottom: none;
}

a.nav-link.active {
  border-left: none;
  border-right: none;
  border-radius: 0;
  border-top: 2px solid #000 !important;
}

.new-post-btn {
  width: 50px;
  height: 50px;
  background-color: #f0f0f0;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.head-top {
  border-top: 1px solid #ddd;
  text-align: center;
}

#radius-shape-1 {
  display: none;
}

#radius-shape-2 {
  display: none;
}

.d-flex.justify-content-center.gap-3.resp_add_social_info {
  flex-wrap: wrap;
}

.d-flex.justify-content-center.gap-3.resp_add_social_info .insta_button_css {
  padding: 5px 15px !important;
}

.content-dasboard .card {
  background: #fff;
  box-shadow: rgb(149 157 165 / 7%) 0px 8px 24px;
  padding: 30px 30px !important;
  border: none !important;
  outline: none !important;
  border-color: transparent !important;
  border-radius: 18px;
}

.card.siz-card {
  max-width: 580px;
  margin: auto;
  margin-left: 0 !important;
}

.card.siz-card .form-control {
  min-height: 50px;
}

.card.siz-card .btn.btn-primary.w-100 {
  min-height: 50px;
}

.flex-repet {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}

.flex-repet .ant-card.ant-card-bordered {
  width: 100%;
  margin: 0 0 30px 0;
}

div#post {
  padding: 0;
}

.card-body.p-4.insta-body .form-control[type="file"] {
  /* height: 35px !important; */
  min-height: 35px !important;
}

.recording_css button {
  border: navajowhite;
  padding: 10px;
  border-radius: 10px;
}

.text_area_css__post {
  width: 100% !important;
}

.flex-repet .ant-ribbon-wrapper {
  width: 30%;
  margin: 0 15px;
}

.flex-repet .ant-card.ant-card-bordered {
  height: calc(100% - 30px);
}
/* .Answer_cssAiagent.my-4 img {
  height: auto !important;
  width: 100% !important;
  max-width: 91% !important;
} */

.Answer_cssAiagent.my-4 img.AI-image {
  max-width: 65px !important;
}
p.no-dt {
  font-size: 25px;
  text-align: center;
  margin-top: 15px;
}

::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(217, 231, 245, 0.3);
  border-radius: 10px;
}

::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.3);
  -webkit-box-shadow: inset 0 0 6px rgba(217, 231, 245, 0.3);
}

::-webkit-scrollbar-thumb:window-inactive {
  background: rgba(207, 255, 255, 0.3);
}

.chart {
  position: relative;
  width: 100%;
  height: auto;
}

.history_user_css {
  cursor: pointer;
  width: 25px;
  height: 21px;
}

@media (max-width: 768px) {
  .chart canvas {
    width: 100% !important;
    height: auto !important;
  }

  .video_resp_css {
    width: 198px !important;
    height: 160px !important;
  }
}

.admin_resp_css {
  margin-left: 0 !important;
}

.text_resp_css {
  word-wrap: break-word !important;
  white-space: normal !important;
}

.icon_resp_css {
  margin-left: 0 !important;
}

.Answer_cssAiagent {
  max-width: 100% !important;
}

.submenu {
  padding-left: 20px;
  list-style-type: none;
}

.submenu li {
  margin-top: 5px;
}

.submenu-caret {
  margin-left: 5px;
}

.demo-flex span.ant-tag.ant-tag-red {
  white-space: unset !important;
}

@media (max-width: 1024px) {
  .dasboard-all.pages {
    min-height: calc(100vh - 165px);
  }
  .profile-pic {
    width: 140px;
    height: 140px;
  }
  .profile-name.col-lg-8 {
    padding-top: 18px !important;
  }
  .flex-repet .ant-ribbon-wrapper {
    width: 45%;
  }
  .card.siz-card {
    max-width: 100%;
  }
  .background-radial-gradient-instagram.overflow-hidden div {
    max-width: 100% !important;
  }
  .ant-tabs-content.ant-tabs-content-top div {
    max-width: 100% !important;
  }
  .flex-repet .ant-ribbon-wrapper {
    width: 100%;
  }
  .message_cssAiagent {
    height: calc(100vh - 350px);
  }
  .Chat_bot_css {
    height: calc(100vh - 224px);
  }
  .chart {
    width: 100%;
    height: auto;
  }
}

@media (max-width: 767px) {
  .gemini_css {
    height: calc(100vh - 170px) !important;
  }
  .bottom-fixed {
    width: 100% !important;
  }
  .Gemini_cssAiagent {
    width: 100% !important;
    margin: 8px 0 8px 0px !important;
  }
  .pad-privasy {
    padding: 65px 15px 30px 15px !important;
  }

  .resp_progress_css {
    word-wrap: break-word !important;
    white-space: normal !important;
  }

  .ant-progress-text {
    width: 100% !important;
  }
  .privacyPolicy_css h1 {
    font-size: 28px !important;
  }
  .privacyPolicy_css h1 {
    font-size: 28px !important;
  }
  .privacyPolicy_css {
    padding: 22px 22px;
  }
  .main-div-msg .input-box button .mx-2 {
    font-size: 14px;
  }
  .privacyPolicy_css {
    padding: 22px 22px;
  }
  .side-bar {
    overflow: auto;
  }
  .tog-bt {
    position: relative !important;
    top: 12px;
  }
  .dasboard-all.top-header {
    padding: 15px 0 15px 0;
  }
  .header-flex ul li.d-flex.align-items-center.flex-wrap {
    display: flex;
    justify-content: flex-end;
    margin: 0 0 0px 0;
  }
  .wallet-address {
    margin: 0 10px 0 0;
    padding: 8px 8px !important;
  }
  .header-flex ul {
    align-items: flex-start;
  }
  .header-flex ul li {
    margin: 0 15px 0px 0;
  }
  .flex-repet .ant-card.ant-card-bordered {
    width: 100% !important;
  }

  .text_area_css__post {
    width: 100% !important;
  }

  .flex-repet .ant-ribbon-wrapper {
    width: 100%;
    margin: 0 0 0px 0;
  }

  .card-body.p-4.insta-body .form-control[type="file"] {
    /* height: 35px !important; */
    min-height: 35px !important;
    width: 100% !important;
  }

  .first-box {
    width: 100%;
    margin-bottom: 15px;
  }

  button.w-100.p-2.gmail_button_css {
    width: 100% !important;
  }

  .content-dasboard ul.text-muted {
    flex-wrap: wrap;
    gap: 3px;
  }

  .content-dasboard ul.text-muted li {
    width: 100%;
  }

  .content-dasboard .container.mt-4 {
    padding-left: 0;
    padding-right: 0;
  }

  .content-dasboard .container.mt-5 {
    padding-left: 0;
    padding-right: 0;
  }

  .privacyPolicy_css {
    padding: 30px 30px;
  }
  .message_cssAiagent {
    height: calc(100vh - 450px);
  }

  .input-box {
    width: 90%;
  }

  .card.siz-card {
    padding: 0px !important;
  }

  .content-dasboard .card {
    box-shadow: none;
    padding: 15px 15px !important;
  }

  .profile-section .card-body {
    padding: 15px 30px;
  }
  .chart {
    width: 100%;
    height: auto;
  }
}

@media (max-width: 991px) {
  .ant-tabs-content.ant-tabs-content-top div {
    max-width: 100% !important;
  }
  ul.text-muted {
    flex-wrap: wrap;
    gap: 15px;
  }
  ul.text-muted li {
    width: 100%;
  }
  .chart {
    width: 100%;
    height: auto;
  }
}

@media (max-width: 1190px) {
  .dasboard-all.pages {
    min-height: calc(100vh - 165px);
  }
  .message_cssAiagent {
    height: calc(100vh - 390px);
  }
  .Chat_bot_css {
    height: calc(100vh - 224px);
  }
  .chart {
    width: 100%;
    height: auto;
  }
}

@media (max-width: 1390px) {
  .dasboard-all.pages {
    min-height: calc(100vh - 124px);
  }
  .message_cssAiagent {
    height: calc(100vh - 337px);
  }
  .Chat_bot_css {
    height: calc(100vh - 224px);
  }
  .chart {
    width: 100%;
    height: auto;
  }

  .resp_login_img {
    width: 100%;
  }
}

.left-align-table .ant-table-cell {
  text-align: left !important;
}

.chat-answer {
  color: black;
  display: flex;
  align-items: center;
  height: 100%;
}

.AI-image {
  width: 55px;
  border-radius: 50%;
}

.loading {
  top: 50%;
  z-index: 9999999 !important;
  height: 50px;
  display: flex;
  align-items: center;
}

.obj {
  width: 6px;
  height: 0px;
  background: #17a2b8;
  margin: 0 3px;
  border-radius: 10px;
  animation: loading 1.2s infinite;
}

.obj:nth-child(2) {
  animation-delay: 0.15s;
}

.obj:nth-child(3) {
  animation-delay: 0.3s;
}

.obj:nth-child(4) {
  animation-delay: 0.45s;
}

.obj:nth-child(5) {
  animation-delay: 0.6s;
}

.obj:nth-child(6) {
  animation-delay: 0.75s;
}

.obj:nth-child(7) {
  animation-delay: 0.9s;
}

.obj:nth-child(8) {
  animation-delay: 1.05s;
}

@keyframes loading {
  0% {
    height: 0;
  }

  50% {
    height: 50px;
  }

  100% {
    height: 0;
  }
}

.wallet-container {
  display: inline-block;
  position: relative;
}

.wallet-address {
  display: inline-flex;
  align-items: center;
  padding: 8px 16px;
  background-color: #007bff;
  color: #fff;
  border-radius: 4px;
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;
  transition: background-color 0.3s, box-shadow 0.3s;
  border: 1px solid transparent;
}

.wallet-address:hover {
  background-color: #0056b3;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  border-color: #003d7a;
}

.wallet-address:focus {
  outline: none;
}

.copy-message {
  position: absolute;
  top: 40px;
  left: 100px;
  transform: translateX(-50%);
  margin-top: 8px;
  background-color: #19c742;
  color: #fff;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
}

label.ant-form-item-required {
  min-width: 100px !important;
}

/* ////adminnnnnnnnnnnnnnnnnnn */

.login-containeradmin {
  display: flex;
  width: 70%;
  max-width: 1000px;
  background-color: #001819;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
}

.login-containeradmin {
  display: flex;
  width: 50%;
  position: relative;
  top: 100px;
  justify-content: center !important;
  margin: auto;
  background-color: #001819;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
}

.login-leftadmin {
  width: 50%;
  background-color: #022a2e;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.login-leftadmin h1 {
  color: #ffffff;
  margin-top: 20px;
}

.logoadmin img {
  width: 100px;
  height: auto;
}

.login-rightadmin {
  width: 50%;
  background-color: #0f3033;
  color: white;
  padding: 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.login-rightadmin h2 {
  margin-bottom: 10px;
}

.login-rightadmin p {
  margin-bottom: 20px;
}

.formadmin {
  display: flex;
  flex-direction: column;
}

.formadmin input {
  padding: 10px;
  margin-bottom: 15px;
  border: none;
  border-radius: 5px;
}

.formadmin button {
  padding: 10px;
  background-color: #ff6600;
  border: none;
  border-radius: 5px;
  color: white;
  font-weight: bold;
  cursor: pointer;
  margin-bottom: 20px;
}

.formadmin button:hover {
  background-color: #ff8533;
}

.formadmin a {
  color: #ff6600;
  text-decoration: none;
}

.formadmin a:hover {
  text-decoration: underline;
}

.Upload_image_css {
  display: flex !important;
  align-items: center !important;
  margin-top: 25px !important;
}

.prompt_enhancer_css{
  margin-top: 20px !important;
}

.upload_btn_css {
  height: 35px !important;
}

.main-div-msg .ant-upload-list-item.ant-upload-list-item-undefined {
  height: 35px !important;
  margin: 0 0 0 5px !important;
}

.main-div-msg .ant-upload-list-item.ant-upload-list-item-undefined {
  height: 35px !important;
  margin: 0 0 0 5px !important;
}
.main-div-msg .first-button .dropdown.my-3 {
  margin: 0 !important;
}
.main-div-msg .first-button {
  margin: 0 !important;
  background: #fff !important;
}
.main-div-msg .first-btn {
  background: #fff !important;
}

@media (max-width: 768px) {
  .ant-table {
    font-size: 12px;
  }
  .ant-modal {
    width: 90% !important;
  }
}


/* /////STREAK CSSS  */


.streak-card {
  width: 100%;
  height: 100%;
}


.title {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 15px;
}

.streak-header {
  display: flex;
  align-items: center;
  gap: 12px;
}

.flame {
  font-size: 36px;
  color: #7ac943;
}

.subtitle {
  color: #888;
  margin: 0;
  font-size: 14px;
}

.streak-count {
  margin: 0;
  font-size: 28px;
  font-weight: 600;
}

.divider {
  height: 1px;
  background: #eee;
  margin: 15px 0;
}

.days-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
}

.day-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.circle {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  margin-bottom: 6px;
}

.completed {
  background-color: #7ac943;
  color: white;
}

.incomplete {
  border: 2px dashed #7ac943;
  color: #7ac943;
}

.day-label {
  font-size: 12px;
  color: #555;
}

.message {
  font-size: 14px;
  color: #888;
}

.equal-card {
  height: 100%;
  border-radius: 16px;
}

.ant-row {
  display: flex;
}

.ant-col {
  display: flex;
}

.ant-col .ant-card {
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,4CAA4C;;AAE5C;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,8BAA8B;EAC9B,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,wDAAwD;AACxD;EACE,YAAY;EACZ,8BAA8B;EAC9B,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,0BAA0B;EAC1B,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,8CAA8C;EAC9C,kBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;EACxB,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;;GAEG;;AAEH;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,OAAO;EACP,MAAM;EACN,gBAAgB;EAChB,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,8CAA8C;AAChD;AACA;;GAEG;;AAEH;EACE,mDAA6C;EAC7C,qBAAqB;EACrB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;;;;;;;;;;GAUG;;AAEH;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;;EAEpB,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,eAAe;EACf,2BAA2B;EAC3B,6BAA6B;EAC7B,0BAA0B;EAC1B,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;EAC/B,oBAAoB;EACpB,4BAA4B;EAC5B,YAAY;EACZ,WAAW;AACb;;AAEA;;GAEG;;AAEH;EACE,aAAa;AACf;;AAEA;;GAEG;;AAEH;EACE,aAAa;AACf;;AAEA;;GAEG;;AAEH;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,8CAA8C;EAC9C,uBAAuB;EACvB,wBAAwB;EACxB,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;EAChC,gBAAgB;EAChB,4BAA4B;EAC5B,kCAAkC;EAClC,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,aAAa;EACb,gBAAgB;AAClB;;AAEA;;;;;;;GAOG;;AAEH;EACE,WAAW;EACX,WAAW;EACX,oCAAoC;AACtC;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA,iFAAiF;AACjF;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,8BAA8B;EAChC;;EAEA;IACE,4BAA4B;IAC5B,YAAY;IACZ,sBAAsB;IACtB,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,SAAS;EACX;;EAEA;;;;;;;;;;;;KAYG;;EAEH;IACE,WAAW;IACX,eAAe;IACf,eAAe;IACf,UAAU;IACV,UAAU;IACV,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,cAAc;IACd,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;IACvB,8BAA8B;IAC9B,wBAAwB;IACxB,6BAA6B;EAC/B;;EAEA;IACE,wBAAwB;IACxB,6BAA6B;IAC7B,0CAA0C;IAC1C,kBAAkB;EACpB;;EAEA;IACE,6BAA6B;IAC7B,uBAAuB;IACvB,wBAAwB;IACxB,8BAA8B;IAC9B,YAAY;IACZ,uBAAuB;EACzB;AACF;;AAEA;EACE,MAAM;EACN,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,8CAA8C;EAC9C,6BAA6B;EAC7B,uBAAuB;EACvB,wBAAwB;EACxB,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,8GAA8G;EAC9G,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;;;;;;;;;;;EAYE,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,kCAAkC;EAClC,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,wCAAwC;AAC1C;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,WAAW;EACX,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,cAAc;EACd,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,WAAW;EACX,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,WAAW;EACX,aAAa;AACf;;AAEA;EACE,aAAa;EACb,cAAc;EACd,YAAY;EACZ,WAAW;EACX,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,WAAW;EACX,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,cAAc;EACd,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,WAAW;EACX,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,WAAW;EACX,aAAa;AACf;;AAEA;EACE,aAAa;EACb,cAAc;EACd,YAAY;EACZ,WAAW;EACX,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;AACF;;AAEA;;GAEG;;AAEH;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE;IACE,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,2BAA2B;IAC3B,aAAa;IACb,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;;;;;GAKC;;EAED;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA;EACE,gDAAgD;EAChD,aAAa;EACb,aAAa;EACb,YAAY;EACZ,aAAa;EACb,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA;EACE,mDAAmD;EACnD,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,8CAA8C;EAC9C,uBAAuB;EACvB,wBAAwB;EACxB,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,8CAA8C;EAC9C,uBAAuB;EACvB,wBAAwB;EACxB,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE;IACE,gDAAgD;IAChD,aAAa;IACb,qBAAqB;IACrB,YAAY;IACZ,aAAa;IACb,6CAA6C;IAC7C,gBAAgB;EAClB;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,2BAA2B;EAC3B,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,2BAA2B;EAC3B,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,+BAA+B;EAC/B,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,2BAA2B;EAC3B,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,+BAA+B;EAC/B,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,8CAA8C;EAC9C,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;;EAEE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,8CAA8C;EAC9C,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,8CAA8C;EAC9C,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,UAAU;EACV,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;;EAEE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA,0DAA0D;;AAE1D;;;;;;;;;;;;;;;;;GAiBG;;AAEH;EACE,aAAa;EACb,kBAAkB;EAClB,qBAAqB;;EAErB,iBAAiB;EACjB,8CAA8C;EAC9C,uBAAuB;EACvB,wBAAwB;EACxB,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,+BAA+B;EAC/B,iBAAiB;EACjB,8CAA8C;EAC9C,uBAAuB;EACvB,wBAAwB;EACxB,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,+BAA+B;EAC/B,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,8BAA8B;EAC9B,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,eAAe;EACf,yCAAyC;EACzC,YAAY;EACZ,cAAc;EACd,OAAO;EACP,QAAQ;AACV;;AAEA,kCAAkC;;AAElC;EACE,mBAAmB;EACnB,gCAAgC;EAChC,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA,uFAAuF;;AAEvF;EACE,8BAA8B;EAC9B,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA,cAAc;AACd;EACE;IACE,QAAQ;EACV;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,qBAAqB;EACrB,QAAQ;EACR,uCAAuC;AACzC;;AAEA,yCAAyC;AACzC;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,SAAS;AACX;;AAEA;EACE,UAAU;EACV,oBAAoB;EACpB,aAAa;EACb,uBAAuB;AACzB;;AAEA,uEAAuE;;AAEvE;EACE,aAAa;EACb,WAAW;EACX,eAAe;EACf,aAAa;EACb,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,0BAA0B;EAC1B,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;GAEG;;AAEH;EACE,qBAAqB;AACvB;;AAEA;EACE,yCAAyC;EACzC,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,gBAAgB;EAChB,8CAA8C;EAC9C,6BAA6B;EAC7B,uBAAuB;EACvB,wBAAwB;EACxB,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,8CAA8C;EAC9C,kBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;EACxB,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,uBAAuB;EACvB,0BAA0B;EAC1B,yDAAyD;AAC3D;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;GAEG;;AAEH;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,8CAA8C;EAC9C,uBAAuB;EACvB,wBAAwB;EACxB,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,8CAA8C;EAC9C,uBAAuB;EACvB,wBAAwB;EACxB,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,eAAe;IACf,qBAAqB;IACrB,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,QAAQ;IACR,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,+BAA+B;IAC/B,kBAAkB;EACpB;AACF;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA,qCAAqC;;AAErC;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,OAAO;EACP,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,OAAO;AACT;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,uCAAuC;EACvC,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,8BAA8B;EAC9B,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;EACxB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,qBAAqB;IACrB,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,8CAA8C;EAC9C,6BAA6B;EAC7B,uBAAuB;EACvB,wBAAwB;EACxB,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;AACA;;;;GAIG;;AAEH;EACE,0BAA0B;AAC5B;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,0DAA0D;EAE1D,mBAAmB;AACrB;;AAEA;EAEE,mBAAmB;EACnB,oCAAoC;EACpC,0DAA0D;AAC5D;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE;IACE,+BAA+B;EACjC;EACA;IACE,YAAY;IACZ,aAAa;EACf;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,UAAU;EACZ;EACA;IACE,eAAe;EACjB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,WAAW;EACb;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,sCAAsC;EACxC;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;IACtB,gCAAgC;EAClC;EACA;IACE,uCAAuC;EACzC;;EAEA;IACE,gCAAgC;IAChC,8BAA8B;EAChC;;EAEA;IACE,sBAAsB;EACxB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,cAAc;EAChB;EACA;IACE,6BAA6B;IAC7B,SAAS;EACX;EACA;IACE,sBAAsB;EACxB;EACA;IACE,aAAa;IACb,yBAAyB;IACzB,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,2BAA2B;EAC7B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,6BAA6B;IAC7B,2BAA2B;IAC3B,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;EACA;IACE,2BAA2B;EAC7B;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,6BAA6B;EAC/B;;EAEA;IACE,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,eAAe;IACf,SAAS;EACX;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,+BAA+B;EACjC;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,+BAA+B;EACjC;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,QAAQ;EACR,2BAA2B;EAC3B,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,kDAAkD;EAClD,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;EACxC,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,2BAA2B;EAC3B,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,gCAAgC;;AAEhC;EACE,aAAa;EACb,UAAU;EACV,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,UAAU;EACV,kCAAkC;EAClC,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;AAC9B;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;EACpB,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,qBAAqB;EACvB;AACF;;;AAGA,sBAAsB;;;AAGtB;EACE,WAAW;EACX,YAAY;AACd;;;AAGA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb","sourcesContent":["/* @import url(\"./style/cssFileName.css\"); */\n\n.App {\n  text-align: center;\n}\n\n.tawkloader_css {\n  position: fixed;\n  bottom: 17px;\n  right: 23px;\n  background-color: #BCE879;\n  padding: 12px;\n  border-radius: 50%;\n  height: 65px;\n  cursor: pointer;\n  z-index: 9999999999999 !important;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n.form-wrapper {\n  background-color: #222629;\n  color: #fff;\n}\n\ninput.react-international-phone-input {\n  width: 100%;\n}\n\n.pass-toggle {\n  text-align: end;\n  position: absolute;\n  right: 25px;\n  top: 40px;\n}\n\n.pass-toggle1 {\n  text-align: end;\n  position: absolute;\n  right: 25px;\n  top: 48px;\n}\n\n.pass-toggle-reg {\n  text-align: end;\n  position: absolute;\n  right: 25px;\n  top: 40px;\n}\n\n.password-toggle-icon {\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n}\n\n.center {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.header {\n  display: flex;\n  align-items: center;\n  padding: 0.5rem;\n}\n\n.logo-container {\n  flex: 0 0 auto;\n}\n\n.logo {\n  height: 55px;\n  width: 100px;\n  cursor: pointer;\n}\n\n.ant-upload.ant-upload-select {\n  margin: 0 15px 0 0;\n}\n\n.ant-form-item-explain-error {\n  text-align: start;\n}\n\nspan.ant-upload-list-item-name {\n  word-break: break-all;\n  max-width: 170px;\n}\n\n.profile-edit {\n  border: none;\n  background: #17c1e8 !important;\n  color: white;\n  width: 116px;\n  height: 35px;\n  border-radius: 7px;\n  align-items: right;\n  margin: 0px 25px 0 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n/* //////////////////////////////////////////////////  */\n.profile-update {\n  border: none;\n  background: #58838d !important;\n  color: white;\n  width: 116px;\n  height: 35px;\n  border-radius: 7px;\n  align-items: right;\n  margin: 0px 79px 0 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.ant-modal-body {\n  padding: 30px 30px 0 30px !important;\n}\n\n.ant-modal-footer {\n  margin: 0 0 0 0 !important;\n  padding: 0 30px 30px 30px !important;\n}\n\n.profile-section .card-body {\n  background: #fff;\n  box-shadow: rgb(149 157 165 / 7%) 0px 8px 24px;\n  padding: 40px 40px;\n  border: none !important;\n  outline: none !important;\n  border-color: transparent !important;\n  border-radius: 18px;\n}\n\n.profile-section .card.mb-4 {\n  border: none !important;\n  background: transparent !important;\n}\n\n.content-dasboard h1.ant-typography.css-dev-only-do-not-override-98ntnt {\n  color: #3e3e3e;\n}\n\n.button.ant-btn.css-dev-only-do-not-override-1drr2mu.ant-btn-default {\n  float: left;\n}\n\n.active {\n  background-color: #000;\n}\n\n.resend-otp {\n  text-align: center;\n  margin-top: 20px;\n}\n\n.btn-100 {\n  width: 100%;\n}\n\n/* ::-webkit-scrollbar {\n  width: 5px;\n} */\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\nbody {\n  background: #f8f9fa;\n  font-family: \"Jost\", sans-serif;\n}\n\n.side-bar {\n  min-height: 100vh;\n  max-height: calc(100% - 0px);\n  transform: translateX(0%);\n  width: 240px;\n  position: fixed;\n  left: 0;\n  top: 0;\n  transition: 0.5s;\n  z-index: 1;\n  overflow: auto;\n  background: #fff;\n  box-shadow: rgb(149 157 165 / 7%) 0px 8px 24px;\n}\n/* ul.link-ul a {\n  color: #fff !important;\n} */\n\n.login_background_css {\n  background: url(\"./Utils/Images/aiimage.jpg\");\n  background-size: auto;\n  background-color: #222629;\n  min-height: 100vh;\n}\n\n.open-class .side-bar {\n  left: -260px;\n}\n\n.open-class .dasboard-all .container-fluid {\n  padding-left: 30px;\n}\n\n.logo-sec h1 {\n  color: #17c1e8 !important;\n}\n\n.link-ul {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n/* .link-ul li a {\n  font-size: 16px;\n  color: #67748e;\n  text-decoration: none;\n  display: block;\n  padding: 10px 25px;\n  border-radius: 10px;\n  margin: 0 0 5px 0;\n  cursor: pointer;\n  transition: 0.3s;\n} */\n\n.link-ul li a {\n  font-size: 16px;\n  color: #67748e;\n  text-decoration: none;\n  display: block;\n  padding: 10px 25px;\n  border-radius: 10px;\n  margin: 0 0 5px 0;\n  cursor: pointer;\n  transition: 0.3s;\n  align-items: center;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  width: 100%;\n}\n\na.active {\n  cursor: pointer !important;\n}\n\n.link-ul li a.active,\n.link-ul li a:hover {\n  background-color: #17c1e8;\n  color: #fff;\n}\n\n.link-div {\n  padding: 21px 15px;\n}\n\n.logo-top {\n  max-width: 140px;\n  margin: auto;\n  display: block;\n  margin-bottom: 25px;\n}\n\n.dasboard-all .container-fluid {\n  padding-left: 270px;\n  padding-right: 30px;\n  transition: 0.5s;\n}\n\n.link-ul li a i {\n  margin: 0 12px 0 0 !important;\n}\n\n.dasboard-all.top-header {\n  padding: 5px 0 5px 0;\n\n  background: #17c1e8;\n  background: #f8f9fa;\n  border-bottom: 1px solid #efefef;\n}\n\n.header-flex ul {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\nbutton.w-100.p-2.gmail_button_css {\n  background: #141727;\n  color: white;\n  width: 60% !important;\n  font-size: 13px;\n  margin: auto;\n  display: block;\n  padding: 12px 15px !important;\n  border-radius: 0.25rem !important;\n}\n\n.insta_button_css {\n  background: #141727;\n  color: white;\n  width: 60% !important;\n  font-size: 13px;\n  margin: auto;\n  display: block;\n  padding: 12px 15px !important;\n  border-radius: 0.25rem !important;\n}\n\n.tog-bt {\n  display: block;\n  padding: 0px 10px;\n  border-radius: 10px;\n  margin: 0 0 0px 0;\n  transition: 0.3s;\n  background: #98bdff;\n  color: #fff;\n  border: none;\n  height: 35px;\n  width: 45px;\n  text-align: center;\n  line-height: 35px;\n}\n\n.header-flex ul li button {\n  background: #17c1e8 !important;\n  font-size: 14px;\n  font-weight: 600 !important;\n  border-radius: 4px !important;\n  padding: 0 15px !important;\n  height: 40px !important;\n  line-height: 40px !important;\n}\n\n.line-1 {\n  height: 2px;\n  width: 30px;\n  background: #fff;\n  display: block;\n  margin: 4px 0;\n  border-radius: 23px;\n}\n\n.log-out-bt {\n  cursor: pointer;\n  padding: 5px 30px 5px 30px;\n  font-size: 15px;\n  font-weight: 400;\n  height: 40px;\n  font-family: \"Jost\", sans-serif;\n  border-radius: 100px;\n  background: rgb(123 144 183);\n  border: none;\n  color: #fff;\n}\n\n/* .top-header i.fa-solid.fa-bars {\n  display: none;\n} */\n\n.top-header .fa-solid.fa-bars {\n  display: none;\n}\n\n/* .open-class .top-header i.fa-solid.fa-caret-left {\n  display: none;\n} */\n\n.open-class .top-header .fa-solid.fa-caret-left {\n  display: none;\n}\n\n/* .open-class .top-header i.fa-solid.fa-bars {\n  display: block;\n} */\n\n.open-class .top-header .fa-solid.fa-bars {\n  display: block;\n}\n\n.last-table {\n  overflow: auto;\n}\n\n.last-table table {\n  width: 100%;\n  min-width: 800px;\n}\n\n.last-table table thead tr th {\n  font-size: 16px;\n  color: #ffffff;\n  padding: 15px 15px;\n  background: #76b51b;\n  font-weight: bold;\n}\n\n.last-table table tbody tr td {\n  font-size: 16px;\n  color: #535353;\n  padding: 15px 15px;\n  background: #ffffff;\n  font-weight: 400;\n}\n\n.last-table table thead tr th:nth-child(1) {\n  border-top-left-radius: 12px;\n}\n\n.last-table table thead tr th:last-child {\n  border-top-right-radius: 12px;\n}\n\n.last-table table tbody tr:last-child td:nth-child(1) {\n  border-bottom-left-radius: 12px;\n}\n\n.last-table table tbody tr:last-child td:last-child {\n  border-bottom-right-radius: 12px;\n}\n\n.content-dasboard {\n  padding: 10px 0;\n}\n\n.last-table table tbody tr:nth-child(even) td {\n  background: #76b51b14;\n}\n\n.last-table table tbody tr:hover td {\n  background: #76b51b38;\n}\n\n.search-input .same-input {\n  border: 1px solid #f7f7f7;\n  background: #fff;\n  width: 100%;\n  height: 50px;\n  border-radius: 12px;\n  font-size: 16px;\n  padding: 0 15px;\n  max-width: 140px;\n  margin: 0 0 0 0;\n  color: #535353;\n}\n\n.search-input .same-input:hover,\n.search-input .same-input:focus {\n  outline: 2px solid #76b51b;\n}\n\n.input-ul {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.input-ul li {\n  margin: 0 15px 15px 0;\n}\n\n.bt-search {\n  border: 1px solid #f7f7f7;\n  background: #76b51b;\n  width: 100%;\n  height: 50px;\n  border-radius: 12px;\n  font-size: 16px;\n  padding: 0 15px;\n  max-width: 160px;\n  margin: 0 0 0 0;\n  color: #ffffff;\n}\n\n.all-label {\n  color: #535353;\n  font-size: 16px;\n  margin: 0 5px 0 0;\n}\n\n.profile-details {\n  display: flex;\n  justify-content: center;\n}\n\n.form-size {\n  width: 100%;\n  max-width: 600px;\n  background: #fff;\n  padding: 30px;\n  box-shadow: rgb(149 157 165 / 7%) 0px 8px 24px;\n  border: none !important;\n  outline: none !important;\n  border-color: transparent !important;\n  border-radius: 18px;\n}\n\n.profile-edit-modal {\n  max-width: calc(100vw - 32px);\n  margin: 16px auto;\n}\n\n.profile-edit-modal .ant-modal-body {\n  max-height: calc(100vh - 110px);\n  max-height: calc(100dvh - 110px);\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  padding: 16px 20px 20px !important;\n  scrollbar-gutter: stable;\n}\n\n.profile-edit-modal .form-size {\n  max-width: none;\n  padding: 12px;\n  box-shadow: none;\n}\n\n/* .form_custom_css{\n  background: #fff;\n  box-shadow: rgb(149 157 165 / 7%) 0px 8px 24px;\n  border: none !important;\n  outline: none !important;\n  border-color: transparent !important;\n  border-radius: 18px;\n} */\n\n.update-btn {\n  width: 100%;\n  color: #fff;\n  background-color: #17c1e8 !important;\n}\n\n@media (min-width: 768px) {\n  .abs-bk {\n    display: none;\n  }\n}\n\n/* ***********************MOBILE RESPONSIVE CSSS******************************* */\n@media (max-width: 767px) {\n  .dasboard-all .container-fluid {\n    padding-left: 15px;\n    padding-right: 15px;\n  }\n\n  .resp_add_social_info {\n    flex-direction: column;\n    align-items: center !important;\n  }\n\n  .resp_add_social_info button {\n    background: rgb(64, 93, 230);\n    color: white;\n    width: 100% !important;\n    padding: 10px;\n    font-size: 13px;\n  }\n\n  .resp_height {\n    height: 495px !important;\n  }\n\n  .open-class .dasboard-all .container-fluid {\n    padding-left: 15px;\n    padding-right: 15px;\n  }\n\n  .side-bar {\n    left: -270px;\n  }\n\n  .open-class .side-bar {\n    left: 0px;\n  }\n\n  /* .abs-bk i {\n    color: #fff;\n    font-size: 15px;\n    position: fixed;\n    right: -10px;\n    top: 110px;\n    background-color: #17c1e8;\n    width: 20px;\n    height: 20px;\n    text-align: center;\n    border-radius: 30px;\n    line-height: 20px;\n  } */\n\n  .abs-bk .icon {\n    color: #fff;\n    font-size: 15px;\n    position: fixed;\n    right: 0px;\n    top: 110px;\n    background-color: #17c1e8;\n    width: 20px;\n    height: 20px;\n    text-align: center;\n    border-radius: 30px;\n    line-height: 20px;\n  }\n\n  .resp_otp_css {\n    border-radius: 15px;\n    z-index: 99999;\n    width: 321px !important;\n  }\n\n  .resp_otp_css_form input {\n    width: 243px !important;\n  }\n\n  .Chat_bot_css {\n    height: 80vh !important;\n    border-radius: 20px !important;\n    padding: 20px !important;\n    position: relative !important;\n  }\n\n  .chat_bot_input_css input {\n    padding: 10px !important;\n    border-radius: 8px !important;\n    border: 1px solid darkslategrey !important;\n    margin: 0 0 10px 0;\n  }\n\n  .chat_bot_button_css button {\n    border-radius: 8px !important;\n    width: 260px !important;\n    padding: 10px !important;\n    background: #f3797e !important;\n    color: white;\n    border: none !important;\n  }\n}\n\n.login-22 {\n  top: 0;\n  width: 100%;\n  text-align: center;\n  bottom: 0;\n  opacity: 1;\n  z-index: 999;\n  min-height: 100vh;\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 30px 0;\n}\n\n.register_css {\n  margin-top: 0px !important;\n}\n\n.form_css {\n  width: 100% !important;\n  max-width: 580px;\n  margin: 0 !important;\n  background: #fff;\n  box-shadow: rgb(149 157 165 / 7%) 0px 8px 24px;\n  padding: 30px 30px !important;\n  border: none !important;\n  outline: none !important;\n  border-color: transparent !important;\n  border-radius: 18px;\n}\n\n.d-flex.justify-content-center.gap-3.my-5.resp_add_social_info {\n  flex-wrap: wrap;\n}\n\n.instagram_input_css {\n  font-size: 13px;\n  padding: 8px;\n}\n\n.instagram_logo_css {\n  background: radial-gradient(circle at 30% 107%, #fdf497 0%, #fdf497 5%, #fd5949 45%, #d6249f 60%, #285aeb 90%);\n  color: white;\n  border-radius: 24px;\n  padding: 5px;\n  margin-top: 20px;\n}\n\n.Label_css {\n  text-align: center;\n  font-size: 20px;\n  font-weight: 500;\n  font-family: math;\n}\n\n.login-22 a {\n  text-decoration: none;\n}\n\n.login-22 h1,\nh2,\nh3,\nh4,\nh5,\nh6,\n.h1,\n.h2,\n.h3,\n.h4,\n.h5,\n.h6 {\n  font-family: \"Jost\", sans-serif;\n}\n\n.login-22 .form-section {\n  max-width: 550px;\n  margin: 0 auto;\n}\n\n.login-22 .form-section .details {\n  padding: 80px;\n  border-radius: 5px;\n  margin-bottom: 30px;\n  background: #f5f5f5;\n  position: relative;\n  z-index: 0;\n}\n\n.login-22 .form-check-input:checked {\n  display: none;\n}\n\n.login-22 .form-section p {\n  color: #535353;\n  margin-bottom: 0;\n  font-size: 16px;\n}\n\n.login-22 .form-section p a {\n  color: #535353;\n}\n\n.login-22 .form-section ul {\n  list-style: none;\n  padding: 0;\n  margin: 0 0 20px;\n}\n\n.login-22 .form-section .social-list li {\n  display: inline-block;\n  margin-bottom: 5px;\n}\n\n.login-22 .logo-2 img {\n  margin-bottom: 10px;\n  height: 70px;\n}\n\n.login-22 .form-section .thembo {\n  margin-left: 4px;\n}\n\n.login-22 .form-section h3 {\n  margin: 0 0 40px;\n  font-size: 25px;\n  font-weight: 400;\n  font-family: \"Jost\", sans-serif;\n  color: #040404;\n}\n\n.login-22 .form-section .form-group {\n  margin-bottom: 40px;\n}\n\n.login-22 .form-section .form-box {\n  float: left;\n  width: 100%;\n  position: relative;\n  text-align: left;\n}\n\n.login-22 .form-section .form-control {\n  font-size: 16px;\n  outline: none;\n  background: transparent !important;\n  color: #535353;\n  border-radius: 0;\n  padding-left: 0;\n  padding-right: 0;\n  border: none;\n  border-bottom: solid 2px #bdbdbd;\n}\n\n.login-22 .form-section .btn-md {\n  cursor: pointer;\n  padding: 12px 50px 11px 50px;\n  font-size: 15px;\n  font-weight: 400;\n  height: 55px;\n  font-family: \"Jost\", sans-serif;\n  border-radius: 100px;\n}\n\n.login-22 .form-section button:focus {\n  outline: none;\n  outline: 0 auto -webkit-focus-ring-color;\n}\n\n.login-22 .form-section .btn-theme.focus,\n.btn-theme:focus {\n  box-shadow: none;\n}\n\n.login-22 .form-section .terms {\n  margin-left: 3px;\n}\n\n.login-22 .form-section input[type=\"checkbox\"],\ninput[type=\"radio\"] {\n  margin-top: 4px;\n}\n\n.login-22 .form-section .checkbox a {\n  float: right;\n}\n\n.login-22 .form-section .checkbox {\n  margin-bottom: 30px;\n  font-size: 15px;\n}\n\n.login-22 .form-section .form-check {\n  float: left;\n  margin-bottom: 0;\n  padding-left: 0;\n}\n\n.login-22 .form-section .form-check a {\n  color: #535353;\n  float: right;\n}\n\n.login-22 .form-section .form-check-input {\n  position: absolute;\n  margin-left: 0;\n}\n\n.login-22 .form-section .form-check label::before {\n  content: \"\";\n  display: inline-block;\n  position: absolute;\n  width: 18px;\n  height: 18px;\n  top: 2px;\n  margin-left: -25px;\n  border-radius: 0px;\n  background: #f5f5f5;\n  border: solid 2px #bdbdbd;\n}\n\n.login-22 .form-section .form-check-label {\n  padding-left: 25px;\n  margin-bottom: 0;\n  font-size: 16px;\n  color: #535353;\n}\n\n.login-22 .form-section input[type=\"checkbox\"]:checked + label:before {\n  font-weight: 600;\n  color: #fff;\n  line-height: 14px;\n  font-size: 12px;\n  content: \"\\2713\";\n  padding-left: 3px;\n}\n\n.login-22 .form-section .form-control:focus {\n  outline: none;\n  box-shadow: none;\n}\n\n.login-22 .form-section .checkbox-theme input[type=\"checkbox\"]:checked + label::before {\n  color: #fff;\n  background: #76b51b;\n  border: solid 2px #76b51b;\n}\n\n.login-22 .form-section .btn-theme {\n  background: #76b51b;\n  border: none;\n  color: #fff;\n}\n\n.login-22 .form-section .btn-theme:hover {\n  background: #7dc11c;\n}\n\n.login-22 .form-section a.forgot-password {\n  font-size: 16px;\n  color: #535353;\n}\n\n.login-22 .social-list {\n  float: left;\n}\n\n.login-22 .social-list span {\n  margin-right: 5px;\n  font-weight: 500;\n  font-size: 15px;\n  color: #535353;\n}\n\n.login-22 .social-list a {\n  width: 55px;\n  height: 55px;\n  line-height: 55px;\n  text-align: center;\n  display: inline-block;\n  font-size: 15px;\n  color: rgb(255, 255, 255);\n  margin: 0 2px 2px 0;\n  border-radius: 50px;\n}\n\n.login-22-bodycolor .ripple-background {\n  z-index: -999 !important;\n}\n\n.login-22-bodycolor .ripple-background .circle {\n  position: absolute;\n  border-radius: 50%;\n  animation: ripple 15s infinite;\n}\n\n.login-22-bodycolor .ripple-background .small {\n  width: 200px;\n  height: 200px;\n  left: -100px;\n  top: -100px;\n  z-index: -999;\n}\n\n.login-22-bodycolor .ripple-background .medium {\n  width: 400px;\n  height: 400px;\n  left: -200px;\n  bottom: -200px;\n  z-index: -999;\n}\n\n.login-22-bodycolor .ripple-background .large {\n  width: 600px;\n  height: 600px;\n  left: -300px;\n  top: -300px;\n  z-index: -999;\n}\n\n.login-22-bodycolor .ripple-background .xlarge {\n  width: 800px;\n  height: 800px;\n  left: -400px;\n  top: -400px;\n  z-index: -999;\n}\n\n.login-22-bodycolor .ripple-background .xxlarge {\n  width: 1000px;\n  height: 1000px;\n  left: -500px;\n  top: -500px;\n  z-index: -999;\n}\n\n.login-22-bodycolor .ripple-background .shade1 {\n  background: #0000ff26;\n}\n\n.login-22-bodycolor .ripple-background .shade2 {\n  background: #b9b9ff;\n}\n\n.login-22-bodycolor .ripple-background .shade3 {\n  background: #0000ff26;\n}\n\n.login-22-bodycolor .ripple-background .shade4 {\n  background: #0a58ca;\n}\n\n.login-22-bodycolor .ripple-background .shade5 {\n  background: #0000ff26;\n}\n\n@keyframes ripple {\n  0% {\n    transform: scale(0.8);\n  }\n\n  50% {\n    transform: scale(1.2);\n  }\n\n  100% {\n    transform: scale(0.8);\n  }\n}\n\n.login-22 .facebook-bg {\n  background: #4867aa;\n}\n\n.login-22 .facebook-bg:hover {\n  background: #3b589e;\n}\n\n.login-22 .twitter-bg {\n  background: #33ccff;\n}\n\n.login-22 .twitter-bg:hover {\n  background: #2abdef;\n}\n\n.login-22 .google-bg {\n  background: #db4437;\n}\n\n.login-22 .google-bg:hover {\n  background: #cc4437;\n}\n\n.login-22 .linkedin-bg {\n  background: #2392e0;\n}\n\n.login-22 .linkedin-bg:hover {\n  background: #1c82ca;\n  color: #fff;\n}\n\n.ripple-background {\n  z-index: -999 !important;\n}\n\n.ripple-background .circle {\n  position: absolute;\n  border-radius: 50%;\n  animation: ripple 15s infinite;\n}\n\n.ripple-background .small {\n  width: 200px;\n  height: 200px;\n  left: -100px;\n  top: -100px;\n  z-index: -999;\n}\n\n.ripple-background .medium {\n  width: 400px;\n  height: 400px;\n  left: -200px;\n  bottom: -200px;\n  z-index: -999;\n}\n\n.ripple-background .large {\n  width: 600px;\n  height: 600px;\n  left: -300px;\n  top: -300px;\n  z-index: -999;\n}\n\n.ripple-background .xlarge {\n  width: 800px;\n  height: 800px;\n  left: -400px;\n  top: -400px;\n  z-index: -999;\n}\n\n.ripple-background .xxlarge {\n  width: 1000px;\n  height: 1000px;\n  left: -500px;\n  top: -500px;\n  z-index: -999;\n}\n\n.ripple-background .shade1 {\n  background: #76b51b3d;\n}\n\n.ripple-background .shade2 {\n  background: #76b51b1f;\n}\n\n.ripple-background .shade3 {\n  background: #76b51b40;\n}\n\n.ripple-background .shade4 {\n  background: #0a58ca;\n}\n\n.ripple-background .shade5 {\n  background: #76b51b73;\n}\n\n@keyframes ripple {\n  0% {\n    transform: scale(0.8);\n  }\n\n  50% {\n    transform: scale(1.2);\n  }\n\n  100% {\n    transform: scale(0.8);\n  }\n}\n\n/* .dasboard-all.pages {\n  min-height: 100vh;\n} */\n\n.dasboard-all.pages {\n  min-height: calc(100vh - 130px);\n}\n\n.custom-row-bk hr {\n  display: none;\n}\n\n.custom-row-bk .row {\n  padding: 15px 15px;\n  background: #f5f7ff;\n  border-radius: 12px;\n}\n\n.custom-row-bk .row:nth-child(odd) {\n  background: #fff;\n}\n\n.custom-row-bk .text-muted {\n  margin: 0;\n}\n\n.footer {\n  position: sticky;\n  bottom: 0px;\n  width: 100%;\n  background: #fbfbfb;\n}\n\n.footer h1 {\n  font-size: 19px;\n  padding: 0px;\n  font-family: initial;\n  text-align: center;\n  color: white;\n  margin: 0;\n  line-height: 50px;\n}\n\n@media (max-width: 768px) {\n  .form_css {\n    background: #fff;\n    border: 1px solid #dbdada;\n    border-radius: 4px;\n    height: 520px;\n    margin: auto;\n    margin-top: 79px !important;\n    padding: 30px;\n    width: 100%;\n    border-radius: 18px;\n  }\n\n  section.background-radial-gradient.overflow-hidden.min-100 {\n    padding: 0 25px;\n  }\n\n  /* .pass-toggle {\n  text-align: end;\n  position: absolute;\n  right: 40px;\n  top: 249px;\n} */\n\n  .login-22 .form-section .details {\n    padding: 50px 30px;\n  }\n\n  .login-22-bodycolor .ripple-background {\n    display: none;\n  }\n}\n\n@media (max-width: 767px) {\n  .ripple-background {\n    display: none;\n  }\n}\n\n.login-container {\n  width: 100%;\n  max-width: 400px;\n  margin: 0 auto;\n  padding: 20px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n}\n\n.login-form {\n  display: flex;\n  flex-direction: column;\n}\n\n.login-form input {\n  margin-bottom: 10px;\n  padding: 10px;\n  font-size: 16px;\n  border-radius: 5px;\n  border: 1px solid #ccc;\n}\n\n.login-form button {\n  padding: 10px;\n  font-size: 16px;\n  border-radius: 5px;\n  border: none;\n  background-color: #007bff;\n  color: #fff;\n  cursor: pointer;\n}\n\n.login-form button:hover {\n  background-color: #0056b3;\n}\n\n.background-radial-gradient {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.min-100 {\n  min-height: 100vh;\n}\n\n#radius-shape-1 {\n  height: 220px;\n  width: 220px;\n  top: -60px;\n  left: -130px;\n  background: radial-gradient(#44006b, #ad1fff);\n  overflow: hidden;\n}\n\n#radius-shape-2 {\n  border-radius: 38% 62% 63% 37% / 70% 33% 67% 30%;\n  bottom: -40px;\n  right: -110px;\n  width: 300px;\n  height: 300px;\n  background: radial-gradient(#3d383f, #ad1fff);\n  overflow: hidden;\n}\n\n.bg-glass {\n  background-color: hsla(0, 0%, 100%, 0.9) !important;\n  backdrop-filter: saturate(200%) blur(25px);\n}\n\n.bg_login_css {\n  background: #fff;\n  box-shadow: rgb(149 157 165 / 7%) 0px 8px 24px;\n  border: none !important;\n  outline: none !important;\n  border-color: transparent !important;\n  border-radius: 18px;\n}\n\n.bg_register_css {\n  background: #fff;\n  box-shadow: rgb(149 157 165 / 7%) 0px 8px 24px;\n  border: none !important;\n  outline: none !important;\n  border-color: transparent !important;\n  border-radius: 18px;\n}\n\n@media screen and (max-width: 480px) {\n  #radius-shape-2 {\n    border-radius: 38% 62% 63% 37% / 70% 33% 67% 30%;\n    bottom: -60px;\n    right: 0px !important;\n    width: 300px;\n    height: 300px;\n    background: radial-gradient(#44006b, #ad1fff);\n    overflow: hidden;\n  }\n}\n\n.country_css {\n  width: 100%;\n  padding: 5px;\n  border: 1px solid #dbd1d1;\n  border-radius: 4px;\n}\n\n.city_css {\n  width: 100%;\n  padding: 5px;\n  border: 1px solid #dbd1d1;\n  border-radius: 4px;\n}\n\n.Instagram_consent_css_container {\n  max-width: 600px;\n  margin: 0 auto;\n  width: 100%;\n  max-width: 441px;\n  background: #fff;\n  margin-top: 26px !important;\n  margin: auto;\n  height: 570px;\n  border-radius: 7px;\n  padding: 30px;\n  border: 1px solid #dbdada;\n}\n\n.Instagram_consent_css_container h1 {\n  text-align: center;\n}\n\n.Instagram_consent_css_container p {\n  margin-bottom: 20px;\n}\n\n.Instagram_consent_css_container button {\n  display: block;\n  margin: 0 auto;\n  padding: 10px 20px;\n  background-color: #405de6;\n  color: #fff;\n  width: 50%;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.Instagram_consent_css_container button:hover {\n  background-color: #577eea;\n}\n\n.Revoke_css_container {\n  max-width: 600px;\n  margin: 0 auto;\n  width: 100%;\n  max-width: 441px;\n  background: #fff;\n  margin-top: 56px !important;\n  margin: auto;\n  height: 520px;\n  border-radius: 7px;\n  padding: 30px;\n  border: 1px solid #dbdada;\n}\n\n.Revoke_css_container h1 {\n  text-align: center;\n}\n\n.Revoke_css_container p {\n  margin-bottom: 20px;\n}\n\n.Revoke_css_container button {\n  display: block;\n  margin: 0 auto;\n  padding: 10px 20px;\n  /* background-color: #FF5A60; */\n  background-color: #405de6;\n  color: #fff;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.Revoke_css_container button:hover {\n  /* background-color: #FF7B81; */\n  background-color: #577eea;\n}\n\n.form_button_css:hover {\n  background-color: #577eea !important;\n}\n\n.delete_user_css_container {\n  max-width: 600px;\n  margin: 0 auto;\n  width: 100%;\n  max-width: 441px;\n  background: #fff;\n  margin-top: 38px !important;\n  margin: auto;\n  height: 520px;\n  border-radius: 4px;\n  padding: 30px;\n  border: 1px solid #dbdada;\n}\n\n.delete_user_css_container h1 {\n  text-align: center;\n}\n\n.delete_user_css_container p {\n  margin-bottom: 20px;\n}\n\n.delete_user_css_container button {\n  display: block;\n  margin: 0 auto;\n  padding: 10px 20px;\n  /* background-color: #FF5A60; */\n  background-color: #405de6;\n  color: #fff;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.delete_user_css_container button:hover {\n  /* background-color: #FF7B81; */\n  background-color: #577eea;\n}\n\n.footer_custom_css {\n  position: sticky;\n  bottom: 0px;\n  padding: 10px;\n  width: 100%;\n  background: #fbfbfb;\n}\n\n.footer_custom_css h1 {\n  font-size: 19px;\n  padding: 14px;\n  font-family: initial;\n  text-align: center;\n  color: white;\n  height: 10px;\n}\n\n.privacyPolicy_css {\n  background: #fff;\n  box-shadow: rgb(149 157 165 / 7%) 0px 8px 24px;\n  padding: 40px 40px;\n  border: none;\n  outline: none;\n  border-color: transparent;\n  border-radius: 18px;\n}\n\n.privacyPolicy_css h1 {\n  color: #17c1e8;\n  margin: 0 0 22px 0;\n  font-size: 40px !important;\n}\n\n.privacyPolicy_css h5,\n.privacyPolicy_css h3 {\n  color: #141727 !important;\n  margin: 0 0 22px 0;\n}\n\n.privacyPolicy_css p {\n  margin: 0 0 22px 0;\n  color: #67748e;\n}\n\nli.text-list {\n  color: #67748e;\n}\n.tiktok_css {\n  background: #fff;\n  box-shadow: rgb(149 157 165 / 7%) 0px 8px 24px;\n  padding: 30px 30px;\n  border: none;\n  outline: none;\n  border-color: transparent;\n  border-radius: 18px;\n  width: 50%;\n  margin: auto;\n}\n\n.faq_css {\n  background: #fff;\n  box-shadow: rgb(149 157 165 / 7%) 0px 8px 24px;\n  padding: 40px 40px;\n  border: none;\n  outline: none;\n  border-color: transparent;\n  border-radius: 18px;\n  width: 50%;\n  margin: auto;\n  margin-top: 65px;\n}\n\n.faq_css h1 {\n  color: #17c1e8;\n  margin: 0 0 22px 0;\n  font-size: 40px !important;\n}\n\n.faq_css h5,\n.faq_css h3 {\n  color: #141727 !important;\n  margin: 0 0 22px 0;\n}\n\n.faq_css p {\n  margin: 0 0 22px 0;\n  color: #67748e;\n}\n\n/* **************CHATBOT CSSS*************************** */\n\n/* .Chat_bot_css {\n\n  background-color: hsl(218, 41%, 15%);\n  background-image: radial-gradient(650px circle at 0% 0%, hsl(218, 41%, 35%) 15%, hsl(218, 41%, 30%) 35%, hsl(218, 41%, 20%) 75%, hsl(218, 41%, 19%) 80%, transparent 100%),\n    radial-gradient(1250px circle at 100% 100%, hsl(218, 41%, 45%) 15%, hsl(218, 41%, 30%) 35%, hsl(218, 41%, 20%) 75%, hsl(218, 41%, 19%) 80%, transparent 100%);\n\n  border-radius: 20px;\n  padding: 20px;\n  position: relative;\n  padding-bottom: 110px;\n  \n  background: #fff;\n  box-shadow: rgb(149 157 165 / 7%) 0px 8px 24px;\n  border: none !important;\n  outline: none !important;\n  border-color: transparent !important;\n  border-radius: 18px;\n} */\n\n.Chat_bot_css {\n  padding: 20px;\n  position: relative;\n  padding-bottom: 120px;\n\n  background: white;\n  box-shadow: rgb(149 157 165 / 7%) 0px 8px 24px;\n  border: none !important;\n  outline: none !important;\n  border-color: transparent !important;\n  border-radius: 18px;\n}\n\n.input_css_for_all_placeholder {\n  background: #f8f9fa !important;\n  min-height: 20px !important;\n}\n\n.Chat_bot_cssAiagent {\n  padding: 20px;\n  position: relative;\n  padding-bottom: 90px;\n  min-height: calc(100vh - 150px);\n  background: white;\n  box-shadow: rgb(149 157 165 / 7%) 0px 8px 24px;\n  border: none !important;\n  outline: none !important;\n  border-color: transparent !important;\n  border-radius: 18px;\n}\n\n.chat_bot_h1_css h1 {\n  color: #3e3e3e !important;\n  font-size: 40px !important;\n  font-weight: 600 !important;\n  font-family: fangsong !important;\n}\n\n.chat_bot_input_css input {\n  padding: 10px;\n  border-radius: 8px;\n  border: 1px solid darkslategrey;\n  width: 100%;\n  background: #f5f7ff !important;\n}\n\n.chat_bot_button_css.mx-2 button {\n  width: 100%;\n  background: rgb(243, 121, 126);\n  color: white;\n  border: none;\n}\n\n.chat_bot_button_css button {\n  border-radius: 8px;\n  width: 150px;\n  padding: 10px;\n  background: white;\n  border: 1px solid darkslategrey;\n}\n\n.main_input_css {\n  align-items: center;\n  background-color: transparent;\n  /* border: 1px solid #a9a9a9; */\n  border-radius: 12px;\n  padding: 10px;\n  position: absolute;\n  bottom: 20px;\n  width: 95%;\n  flex-wrap: wrap;\n  justify-content: space-between !important;\n  margin: auto;\n  display: block;\n  left: 0;\n  right: 0;\n}\n\n/* **********Question_css******* */\n\n.Question_css {\n  border-radius: 12px;\n  /* border: 1px solid darkgrey; */\n  padding: 5px;\n  background: #f5f7ff;\n}\n\n.Question_cssAiagent {\n  border-radius: 12px;\n  /* border: 1px solid darkgrey; */\n  padding: 5px;\n  background: #f5f7ff;\n  width: fit-content;\n  max-width: 70%;\n}\n\n.Answer_cssAiagent {\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  max-width: 70%;\n  /* border: 1px solid darkgrey; */\n  padding: 15px;\n  background: #f5f7ff;\n  width: fit-content;\n}\n\n.Answer_css {\n  border-radius: 12px;\n  /* border: 1px solid darkgrey; */\n  padding: 15px;\n  background: #f5f7ff;\n}\n\n.message_css {\n  overflow-y: auto;\n  height: 295px;\n}\n\n.message_cssAiagent {\n  overflow-y: auto;\n  height: calc(100vh - 440px);\n  /* min-height: 100vh; */\n}\n\n/* ---------------------------------------------------------------------------------- */\n\n.animated-text {\n  font-family: Arial, sans-serif;\n  white-space: pre-wrap;\n  /* Preserve line breaks */\n  overflow: hidden;\n  /* Hide overflow content */\n}\n\n/* Animation */\n@keyframes typing {\n  from {\n    width: 0;\n  }\n\n  to {\n    width: 100%;\n  }\n}\n\n.animated-text::after {\n  content: \"|\";\n  /* Cursor */\n  display: inline-block;\n  width: 0;\n  animation: typing 1s steps(44) infinite;\n}\n\n/* Hide cursor when text is fully typed */\n.animated-text::after {\n  animation: none;\n}\n\n.chat_bot_input_css {\n  width: 50%;\n  margin: 0;\n}\n\n.chat_bot_button_css.mx-2 {\n  width: 23%;\n  margin: 0 !important;\n  display: flex;\n  justify-content: center;\n}\n\n/* ******************** MAIL CSSS************************************ */\n\n.mail_css {\n  display: flex;\n  width: 100%;\n  background: red;\n  padding: 15px;\n  height: 100vh;\n}\n\n.Insta_css_message {\n  width: 100%;\n  padding: 20px;\n  border-radius: 10px;\n  display: flex;\n  justify-content: center;\n}\n\n.instagram_conatiner_css {\n  /* background: #e1e1e1; */\n  background: white;\n  padding: 20px;\n  border-radius: 7px;\n  padding: 20px;\n  width: 50%;\n}\n\n.mail_css_form {\n  border: 1px solid darkgrey;\n  height: auto;\n  padding: 20px;\n  border-radius: 10px;\n  background: white;\n}\n\n/* .mail_css_form p {\n  word-break: break-all;\n} */\n\n.mail_css_form li {\n  word-break: break-all;\n}\n\n.d-flex.custom-flex-100 .d-flex.justify-content-start.rounded-3.p-2.mb-2.bg-body-tertiary {\n  justify-content: space-between !important;\n  padding: 15px 15px !important;\n}\n\nul.list-name {\n  padding: 20px !important;\n  list-style: none;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-around;\n  text-align: center;\n}\n\nul.list-name li {\n  width: 23%;\n  margin: 0 0 10px 0;\n}\n\nul.list-name hr {\n  display: none !important;\n}\n\n.list-box {\n  height: 110px;\n  overflow-y: auto;\n  padding: 0px;\n}\n\n@media (max-width: 1024px) {\n  .d-flex.justify-content-start.rounded-3.p-2.mb-2.bg-body-tertiary {\n    flex-wrap: wrap;\n  }\n\n  .d-flex.justify-content-start.rounded-3.p-2.mb-2.bg-body-tertiary .px-3 {\n    padding: 0 !important;\n  }\n\n  .wid-100 {\n    width: 100%;\n  }\n}\n\n@media (max-width: 991px) {\n  button.viewpost {\n    width: 100% !important;\n  }\n\n  .cus-m {\n    margin-bottom: 15px !important;\n  }\n\n  .d-flex.custom-flex-100 {\n    flex-wrap: wrap;\n  }\n\n  .d-flex.custom-flex-100 .flex-shrink-0 {\n    width: 100%;\n    margin: 0 0 15px 0;\n  }\n\n  .d-flex.custom-flex-100 .flex-grow-1.ms-3 {\n    margin: 0 0 0 0 !important;\n  }\n\n  .d-flex.custom-flex-100 .wid-100 {\n    width: auto;\n  }\n}\n\n@media (max-width: 767px) {\n  .chat_bot_button_css.mx-2 {\n    width: 46%;\n  }\n\n  .chat_bot_input_css {\n    width: 100%;\n  }\n\n  .message_css {\n    overflow-y: scroll;\n    height: 450px !important;\n  }\n\n  .instagram_conatiner_css {\n    width: 100% !important;\n  }\n}\n\n.content-dasboard .card-body.p-4 {\n  background: #fff;\n  box-shadow: rgb(149 157 165 / 7%) 0px 8px 24px;\n  padding: 30px 30px !important;\n  border: none !important;\n  outline: none !important;\n  border-color: transparent !important;\n  border-radius: 18px;\n}\n\n.content-dasboard .card-body.p-4.insta-body {\n  padding: 0 !important;\n  box-shadow: none !important;\n}\n\n.content-dasboard .card.cus-m {\n  border: none;\n}\n\n.content-dasboard button.my-1.btn.btn-primary {\n  background: #f3797e;\n  border: none;\n  margin: 5px 0 0px 0 !important;\n  width: 100%;\n}\n\n.content-dasboard .flex-grow-1.ms-3 h5.mb-1 {\n  font-weight: bold;\n  color: #3e3e3e;\n}\n\n.content-dasboard .d-flex.justify-content-start.rounded-3.p-2.mb-2.bg-body-tertiary {\n  background: #f5f7ff !important;\n}\n\n.content-dasboard p.mb-0 {\n  font-weight: bold;\n  color: #17c1e8;\n}\n\n.content-dasboard h2.form-header {\n  color: #3e3e3e;\n}\n\n.content-dasboard button.btn.btn-primary.w-100 {\n  background: #f3797e;\n  border: none;\n}\n\n.ant-modal-content {\n  background: #fff;\n  box-shadow: rgb(149 157 165 / 7%) 0px 8px 24px;\n  padding: 40px 40px;\n  border: none !important;\n  outline: none !important;\n  border-color: transparent !important;\n  border-radius: 18px;\n}\n\n.ant-modal-content button.btn.btn-primary.w-100 {\n  background: #f3797e;\n  height: 40px;\n  border: none;\n}\n\n.ant-modal-content input {\n  background: #f5f7ff !important;\n  height: 40px;\n  border: none !important;\n  font-size: 14px !important;\n  box-shadow: rgb(149 157 165 / 7%) 0px 8px 24px !important;\n}\n\n.ant-modal-content label.form-label {\n  margin: 0 0 3px 0;\n}\n\n.ant-modal-content {\n  padding: 0 !important;\n}\n\n.ant-modal-content .ant-modal-header {\n  background: #17c1e8 !important;\n  padding: 15px 15px !important;\n  margin: 0 !important;\n}\n\n.ant-modal-content .ant-modal-title {\n  color: #fff !important;\n}\n\n/* .ant-modal-content svg {\n  fill: white;\n} */\n\n.ant-modal-wrap {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.ant-modal {\n  top: 0 !important;\n  padding: 0 !important;\n}\n\n.background-radial-gradient {\n  overflow: hidden;\n  position: relative;\n}\n\n.background-radial-gradient .d-flex.justify-content-center {\n  width: 100%;\n}\n\n.background-radial-gradient .d-flex.justify-content-center .row.position-absolute {\n  position: static !important;\n  padding: 0 !important;\n}\n\nhtml body .navbar_connect_button_css button.iekbcc0.iekbcc9.ju367v4.ju367va3.ju367vn.ju367vei.ju367vfu.ju367va.ju367v16.ju367v1h.ju367v8u._12cbo8i3.ju367v8r._12cbo8i4._12cbo8i6 {\n  background: transparent !important;\n  box-shadow: none !important;\n}\n\n.verify_otp_css {\n  background: white !important;\n  box-shadow: rgb(149 157 165 / 7%) 0px 8px 24px;\n  border: none !important;\n  outline: none !important;\n  border-color: transparent !important;\n  border-radius: 18px;\n}\n\n.otp_custom_css {\n  background: white !important;\n  box-shadow: rgb(149 157 165 / 7%) 0px 8px 24px;\n  border: none !important;\n  outline: none !important;\n  border-color: transparent !important;\n  border-radius: 18px;\n}\n\n.icons-svg {\n  margin: 0px 10px 4px 0px !important;\n}\n\n.rounded-circle {\n  width: 40px;\n  height: 40px;\n  object-fit: cover;\n  margin: auto;\n  display: block;\n}\n\n.rounded-circleProfile {\n  width: 80px;\n  height: 80px;\n  object-fit: cover;\n  /* margin: auto; */\n  border-radius: 10%;\n  display: block;\n}\n\n.profile-card p {\n  font-size: 12px;\n  margin: 2px 0 0 0;\n}\n\n.abs-mobile {\n  font-size: 14px;\n}\n\n@media (max-width: 1024px) {\n  .abs-mobile {\n    font-size: 10px;\n    word-break: break-all;\n    position: absolute;\n    width: auto;\n    left: 240px;\n    right: 0;\n    bottom: 10px;\n    text-align: center;\n  }\n\n  .dasboard-all.top-header {\n    padding: 5px 0 5px 0 !important;\n    position: relative;\n  }\n}\n\n.Navbar_css a {\n  text-decoration: none;\n  color: black;\n}\n\n/* ******************************** */\n\n.chatai_icon_css {\n  color: #17c1e8 !important;\n}\n\n.delete_chatai_icon_css {\n  color: red;\n}\n\n.main-div-msg {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  width: 100%;\n  bottom: 20px;\n  left: 0;\n  z-index: 99 !important;\n}\n\n.main-div-msgchatbot {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  width: 100%;\n  bottom: 29px;\n  left: 0;\n}\n\n.input-box {\n  width: 100%;\n  max-width: 820px;\n  background-color: white;\n  border-radius: 10px;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n  padding: 10px;\n}\n\n.input-group-text {\n  background-color: #f1f1f1;\n  border: none;\n  border-radius: 10px;\n}\n\n.form-control {\n  border: none;\n  background-color: #f7fdfc;\n  border-radius: 10px;\n}\n\n.form-control:focus {\n  box-shadow: none;\n  outline: none;\n}\n\nul.first-button {\n  display: flex;\n  list-style: none;\n  background: #f8f9fa !important;\n  margin: 10px 0px 0px 0px;\n  border-radius: 10px;\n  padding: 0px 5px;\n  gap: 5px;\n}\n\nul.second-button {\n  display: flex;\n  list-style: none;\n  background: #e2e8f0;\n  margin: 10px 0px 0px 9px;\n  border-radius: 10px;\n  padding: 5px 12px;\n}\n\nul.third-button {\n  display: flex;\n  list-style: none;\n  margin: 10px 0px 0px 9px;\n  border-radius: 10px;\n  padding: 5px 12px;\n  float: right;\n  background: #e2e8f0;\n}\n\nul.first-button li {\n  padding: 7px 10px;\n  border-radius: 10px !important;\n  cursor: pointer !important;\n}\n\n.first-btn {\n  display: flex;\n  justify-content: flex-start;\n  align-items: baseline;\n}\n\nul.first-button li:hover {\n  background: #17c1e8 !important;\n  border-radius: 10px !important;\n  color: #fff !important;\n}\n\nul.second-button:hover {\n  background: #17c1e8 !important;\n  color: #fff !important;\n}\n\nul.third-button:hover {\n  background: #17c1e8 !important;\n  color: #fff !important;\n}\n\nul.first-button,\n.second-button,\n.third-button li i {\n  color: #5c5b5b;\n}\n\n.active_css_aichatbot {\n  background: #17c1e8 !important;\n  color: white;\n}\n\n.right-ms {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.left-ms {\n  display: flex;\n  justify-content: flex-start;\n}\n.chat-wrapper {\n  position: relative;\n}\n\n.copy-button {\n  position: absolute;\n  top: 0;\n  right: 0;\n  padding: 6px 10px;\n  background-color: #17c1e8;\n  font-size: 12px;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  z-index: 1;\n}\n\n.copy-button:hover {\n  background-color: #0056b3;\n}\n\n.chat-container {\n  padding: 10px;\n  border-radius: 8px;\n  margin-top: 15px;\n}\n\n@media (max-width: 767px) {\n  .abs-mobile {\n    font-size: 14px;\n  }\n\n  .tiktok_css {\n    margin-top: 20% !important;\n    width: 100% !important;\n  }\n\n  .abs-mobile {\n    font-size: 10px;\n    word-break: break-all;\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: 10px;\n    text-align: center;\n  }\n\n  .footer_css h1 {\n    margin-left: 0px !important;\n  }\n}\n\n.footer_css h1 {\n  margin-left: 270px;\n  color: #000;\n  transition: 0.6s;\n}\n\n.footer_css_transition h1 {\n  transition: 1s !important;\n  color: #000;\n}\n\n.profile-pic {\n  width: 200px;\n  height: 200px;\n}\n\nul.text-muted {\n  display: flex;\n  font-size: 19px;\n  gap: 40px;\n  list-style: none;\n  padding: 0px;\n}\n\n.text-list {\n  margin-bottom: 10px;\n}\n\n.label {\n  font-size: 18px;\n  color: #888;\n  font-family: math;\n}\n\n.detail {\n  font-size: 18px;\n  font-weight: 600;\n  color: black;\n  margin-top: 5px;\n  font-family: monospace;\n}\n\nh3.profile-detail {\n  font-size: 1.5rem;\n}\n\n.text-muted {\n  font-size: 0.9rem;\n}\n\nimg {\n  object-fit: cover;\n}\n\nul.nav.nav-tabs {\n  border-top: 1px solid #ddd;\n  display: flex;\n  justify-content: center;\n  border-bottom: none;\n}\n\na.nav-link.active {\n  border-left: none;\n  border-right: none;\n  border-radius: 0;\n  border-top: 2px solid #000 !important;\n}\n\n.new-post-btn {\n  width: 50px;\n  height: 50px;\n  background-color: #f0f0f0;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.head-top {\n  border-top: 1px solid #ddd;\n  text-align: center;\n}\n\n#radius-shape-1 {\n  display: none;\n}\n\n#radius-shape-2 {\n  display: none;\n}\n\n.d-flex.justify-content-center.gap-3.resp_add_social_info {\n  flex-wrap: wrap;\n}\n\n.d-flex.justify-content-center.gap-3.resp_add_social_info .insta_button_css {\n  padding: 5px 15px !important;\n}\n\n.content-dasboard .card {\n  background: #fff;\n  box-shadow: rgb(149 157 165 / 7%) 0px 8px 24px;\n  padding: 30px 30px !important;\n  border: none !important;\n  outline: none !important;\n  border-color: transparent !important;\n  border-radius: 18px;\n}\n\n.card.siz-card {\n  max-width: 580px;\n  margin: auto;\n  margin-left: 0 !important;\n}\n\n.card.siz-card .form-control {\n  min-height: 50px;\n}\n\n.card.siz-card .btn.btn-primary.w-100 {\n  min-height: 50px;\n}\n\n.flex-repet {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n}\n\n.flex-repet .ant-card.ant-card-bordered {\n  width: 100%;\n  margin: 0 0 30px 0;\n}\n\ndiv#post {\n  padding: 0;\n}\n\n.card-body.p-4.insta-body .form-control[type=\"file\"] {\n  /* height: 35px !important; */\n  min-height: 35px !important;\n}\n\n.recording_css button {\n  border: navajowhite;\n  padding: 10px;\n  border-radius: 10px;\n}\n\n.text_area_css__post {\n  width: 100% !important;\n}\n\n.flex-repet .ant-ribbon-wrapper {\n  width: 30%;\n  margin: 0 15px;\n}\n\n.flex-repet .ant-card.ant-card-bordered {\n  height: calc(100% - 30px);\n}\n/* .Answer_cssAiagent.my-4 img {\n  height: auto !important;\n  width: 100% !important;\n  max-width: 91% !important;\n} */\n\n.Answer_cssAiagent.my-4 img.AI-image {\n  max-width: 65px !important;\n}\np.no-dt {\n  font-size: 25px;\n  text-align: center;\n  margin-top: 15px;\n}\n\n::-webkit-scrollbar {\n  width: 5px;\n  height: 5px;\n}\n\n::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 6px rgba(217, 231, 245, 0.3);\n  -webkit-border-radius: 10px;\n  border-radius: 10px;\n}\n\n::-webkit-scrollbar-thumb {\n  -webkit-border-radius: 10px;\n  border-radius: 10px;\n  background: rgba(255, 255, 255, 0.3);\n  -webkit-box-shadow: inset 0 0 6px rgba(217, 231, 245, 0.3);\n}\n\n::-webkit-scrollbar-thumb:window-inactive {\n  background: rgba(207, 255, 255, 0.3);\n}\n\n.chart {\n  position: relative;\n  width: 100%;\n  height: auto;\n}\n\n.history_user_css {\n  cursor: pointer;\n  width: 25px;\n  height: 21px;\n}\n\n@media (max-width: 768px) {\n  .chart canvas {\n    width: 100% !important;\n    height: auto !important;\n  }\n\n  .video_resp_css {\n    width: 198px !important;\n    height: 160px !important;\n  }\n}\n\n.admin_resp_css {\n  margin-left: 0 !important;\n}\n\n.text_resp_css {\n  word-wrap: break-word !important;\n  white-space: normal !important;\n}\n\n.icon_resp_css {\n  margin-left: 0 !important;\n}\n\n.Answer_cssAiagent {\n  max-width: 100% !important;\n}\n\n.submenu {\n  padding-left: 20px;\n  list-style-type: none;\n}\n\n.submenu li {\n  margin-top: 5px;\n}\n\n.submenu-caret {\n  margin-left: 5px;\n}\n\n.demo-flex span.ant-tag.ant-tag-red {\n  white-space: unset !important;\n}\n\n@media (max-width: 1024px) {\n  .dasboard-all.pages {\n    min-height: calc(100vh - 165px);\n  }\n  .profile-pic {\n    width: 140px;\n    height: 140px;\n  }\n  .profile-name.col-lg-8 {\n    padding-top: 18px !important;\n  }\n  .flex-repet .ant-ribbon-wrapper {\n    width: 45%;\n  }\n  .card.siz-card {\n    max-width: 100%;\n  }\n  .background-radial-gradient-instagram.overflow-hidden div {\n    max-width: 100% !important;\n  }\n  .ant-tabs-content.ant-tabs-content-top div {\n    max-width: 100% !important;\n  }\n  .flex-repet .ant-ribbon-wrapper {\n    width: 100%;\n  }\n  .message_cssAiagent {\n    height: calc(100vh - 350px);\n  }\n  .Chat_bot_css {\n    height: calc(100vh - 224px);\n  }\n  .chart {\n    width: 100%;\n    height: auto;\n  }\n}\n\n@media (max-width: 767px) {\n  .gemini_css {\n    height: calc(100vh - 170px) !important;\n  }\n  .bottom-fixed {\n    width: 100% !important;\n  }\n  .Gemini_cssAiagent {\n    width: 100% !important;\n    margin: 8px 0 8px 0px !important;\n  }\n  .pad-privasy {\n    padding: 65px 15px 30px 15px !important;\n  }\n\n  .resp_progress_css {\n    word-wrap: break-word !important;\n    white-space: normal !important;\n  }\n\n  .ant-progress-text {\n    width: 100% !important;\n  }\n  .privacyPolicy_css h1 {\n    font-size: 28px !important;\n  }\n  .privacyPolicy_css h1 {\n    font-size: 28px !important;\n  }\n  .privacyPolicy_css {\n    padding: 22px 22px;\n  }\n  .main-div-msg .input-box button .mx-2 {\n    font-size: 14px;\n  }\n  .privacyPolicy_css {\n    padding: 22px 22px;\n  }\n  .side-bar {\n    overflow: auto;\n  }\n  .tog-bt {\n    position: relative !important;\n    top: 12px;\n  }\n  .dasboard-all.top-header {\n    padding: 15px 0 15px 0;\n  }\n  .header-flex ul li.d-flex.align-items-center.flex-wrap {\n    display: flex;\n    justify-content: flex-end;\n    margin: 0 0 0px 0;\n  }\n  .wallet-address {\n    margin: 0 10px 0 0;\n    padding: 8px 8px !important;\n  }\n  .header-flex ul {\n    align-items: flex-start;\n  }\n  .header-flex ul li {\n    margin: 0 15px 0px 0;\n  }\n  .flex-repet .ant-card.ant-card-bordered {\n    width: 100% !important;\n  }\n\n  .text_area_css__post {\n    width: 100% !important;\n  }\n\n  .flex-repet .ant-ribbon-wrapper {\n    width: 100%;\n    margin: 0 0 0px 0;\n  }\n\n  .card-body.p-4.insta-body .form-control[type=\"file\"] {\n    /* height: 35px !important; */\n    min-height: 35px !important;\n    width: 100% !important;\n  }\n\n  .first-box {\n    width: 100%;\n    margin-bottom: 15px;\n  }\n\n  button.w-100.p-2.gmail_button_css {\n    width: 100% !important;\n  }\n\n  .content-dasboard ul.text-muted {\n    flex-wrap: wrap;\n    gap: 3px;\n  }\n\n  .content-dasboard ul.text-muted li {\n    width: 100%;\n  }\n\n  .content-dasboard .container.mt-4 {\n    padding-left: 0;\n    padding-right: 0;\n  }\n\n  .content-dasboard .container.mt-5 {\n    padding-left: 0;\n    padding-right: 0;\n  }\n\n  .privacyPolicy_css {\n    padding: 30px 30px;\n  }\n  .message_cssAiagent {\n    height: calc(100vh - 450px);\n  }\n\n  .input-box {\n    width: 90%;\n  }\n\n  .card.siz-card {\n    padding: 0px !important;\n  }\n\n  .content-dasboard .card {\n    box-shadow: none;\n    padding: 15px 15px !important;\n  }\n\n  .profile-section .card-body {\n    padding: 15px 30px;\n  }\n  .chart {\n    width: 100%;\n    height: auto;\n  }\n}\n\n@media (max-width: 991px) {\n  .ant-tabs-content.ant-tabs-content-top div {\n    max-width: 100% !important;\n  }\n  ul.text-muted {\n    flex-wrap: wrap;\n    gap: 15px;\n  }\n  ul.text-muted li {\n    width: 100%;\n  }\n  .chart {\n    width: 100%;\n    height: auto;\n  }\n}\n\n@media (max-width: 1190px) {\n  .dasboard-all.pages {\n    min-height: calc(100vh - 165px);\n  }\n  .message_cssAiagent {\n    height: calc(100vh - 390px);\n  }\n  .Chat_bot_css {\n    height: calc(100vh - 224px);\n  }\n  .chart {\n    width: 100%;\n    height: auto;\n  }\n}\n\n@media (max-width: 1390px) {\n  .dasboard-all.pages {\n    min-height: calc(100vh - 124px);\n  }\n  .message_cssAiagent {\n    height: calc(100vh - 337px);\n  }\n  .Chat_bot_css {\n    height: calc(100vh - 224px);\n  }\n  .chart {\n    width: 100%;\n    height: auto;\n  }\n\n  .resp_login_img {\n    width: 100%;\n  }\n}\n\n.left-align-table .ant-table-cell {\n  text-align: left !important;\n}\n\n.chat-answer {\n  color: black;\n  display: flex;\n  align-items: center;\n  height: 100%;\n}\n\n.AI-image {\n  width: 55px;\n  border-radius: 50%;\n}\n\n.loading {\n  top: 50%;\n  z-index: 9999999 !important;\n  height: 50px;\n  display: flex;\n  align-items: center;\n}\n\n.obj {\n  width: 6px;\n  height: 0px;\n  background: #17a2b8;\n  margin: 0 3px;\n  border-radius: 10px;\n  animation: loading 1.2s infinite;\n}\n\n.obj:nth-child(2) {\n  animation-delay: 0.15s;\n}\n\n.obj:nth-child(3) {\n  animation-delay: 0.3s;\n}\n\n.obj:nth-child(4) {\n  animation-delay: 0.45s;\n}\n\n.obj:nth-child(5) {\n  animation-delay: 0.6s;\n}\n\n.obj:nth-child(6) {\n  animation-delay: 0.75s;\n}\n\n.obj:nth-child(7) {\n  animation-delay: 0.9s;\n}\n\n.obj:nth-child(8) {\n  animation-delay: 1.05s;\n}\n\n@keyframes loading {\n  0% {\n    height: 0;\n  }\n\n  50% {\n    height: 50px;\n  }\n\n  100% {\n    height: 0;\n  }\n}\n\n.wallet-container {\n  display: inline-block;\n  position: relative;\n}\n\n.wallet-address {\n  display: inline-flex;\n  align-items: center;\n  padding: 8px 16px;\n  background-color: #007bff;\n  color: #fff;\n  border-radius: 4px;\n  font-weight: 600;\n  cursor: pointer;\n  text-decoration: none;\n  transition: background-color 0.3s, box-shadow 0.3s;\n  border: 1px solid transparent;\n}\n\n.wallet-address:hover {\n  background-color: #0056b3;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n  border-color: #003d7a;\n}\n\n.wallet-address:focus {\n  outline: none;\n}\n\n.copy-message {\n  position: absolute;\n  top: 40px;\n  left: 100px;\n  transform: translateX(-50%);\n  margin-top: 8px;\n  background-color: #19c742;\n  color: #fff;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n}\n\nlabel.ant-form-item-required {\n  min-width: 100px !important;\n}\n\n/* ////adminnnnnnnnnnnnnnnnnnn */\n\n.login-containeradmin {\n  display: flex;\n  width: 70%;\n  max-width: 1000px;\n  background-color: #001819;\n  border-radius: 10px;\n  overflow: hidden;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);\n}\n\n.login-containeradmin {\n  display: flex;\n  width: 50%;\n  position: relative;\n  top: 100px;\n  justify-content: center !important;\n  margin: auto;\n  background-color: #001819;\n  border-radius: 10px;\n  overflow: hidden;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);\n}\n\n.login-leftadmin {\n  width: 50%;\n  background-color: #022a2e;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.login-leftadmin h1 {\n  color: #ffffff;\n  margin-top: 20px;\n}\n\n.logoadmin img {\n  width: 100px;\n  height: auto;\n}\n\n.login-rightadmin {\n  width: 50%;\n  background-color: #0f3033;\n  color: white;\n  padding: 40px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.login-rightadmin h2 {\n  margin-bottom: 10px;\n}\n\n.login-rightadmin p {\n  margin-bottom: 20px;\n}\n\n.formadmin {\n  display: flex;\n  flex-direction: column;\n}\n\n.formadmin input {\n  padding: 10px;\n  margin-bottom: 15px;\n  border: none;\n  border-radius: 5px;\n}\n\n.formadmin button {\n  padding: 10px;\n  background-color: #ff6600;\n  border: none;\n  border-radius: 5px;\n  color: white;\n  font-weight: bold;\n  cursor: pointer;\n  margin-bottom: 20px;\n}\n\n.formadmin button:hover {\n  background-color: #ff8533;\n}\n\n.formadmin a {\n  color: #ff6600;\n  text-decoration: none;\n}\n\n.formadmin a:hover {\n  text-decoration: underline;\n}\n\n.Upload_image_css {\n  display: flex !important;\n  align-items: center !important;\n  margin-top: 25px !important;\n}\n\n.prompt_enhancer_css{\n  margin-top: 20px !important;\n}\n\n.upload_btn_css {\n  height: 35px !important;\n}\n\n.main-div-msg .ant-upload-list-item.ant-upload-list-item-undefined {\n  height: 35px !important;\n  margin: 0 0 0 5px !important;\n}\n\n.main-div-msg .ant-upload-list-item.ant-upload-list-item-undefined {\n  height: 35px !important;\n  margin: 0 0 0 5px !important;\n}\n.main-div-msg .first-button .dropdown.my-3 {\n  margin: 0 !important;\n}\n.main-div-msg .first-button {\n  margin: 0 !important;\n  background: #fff !important;\n}\n.main-div-msg .first-btn {\n  background: #fff !important;\n}\n\n@media (max-width: 768px) {\n  .ant-table {\n    font-size: 12px;\n  }\n  .ant-modal {\n    width: 90% !important;\n  }\n}\n\n\n/* /////STREAK CSSS  */\n\n\n.streak-card {\n  width: 100%;\n  height: 100%;\n}\n\n\n.title {\n  font-size: 20px;\n  font-weight: 600;\n  margin-bottom: 15px;\n}\n\n.streak-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.flame {\n  font-size: 36px;\n  color: #7ac943;\n}\n\n.subtitle {\n  color: #888;\n  margin: 0;\n  font-size: 14px;\n}\n\n.streak-count {\n  margin: 0;\n  font-size: 28px;\n  font-weight: 600;\n}\n\n.divider {\n  height: 1px;\n  background: #eee;\n  margin: 15px 0;\n}\n\n.days-row {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 15px;\n}\n\n.day-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.circle {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: bold;\n  margin-bottom: 6px;\n}\n\n.completed {\n  background-color: #7ac943;\n  color: white;\n}\n\n.incomplete {\n  border: 2px dashed #7ac943;\n  color: #7ac943;\n}\n\n.day-label {\n  font-size: 12px;\n  color: #555;\n}\n\n.message {\n  font-size: 14px;\n  color: #888;\n}\n\n.equal-card {\n  height: 100%;\n  border-radius: 16px;\n}\n\n.ant-row {\n  display: flex;\n}\n\n.ant-col {\n  display: flex;\n}\n\n.ant-col .ant-card {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
